// ----------------------------------------------------------------------

import { title } from 'process';
import { globalDashboardEn } from './modules/globalDashboard.en';
import { privacyEn } from './modules/privacy.en';
import { analyticsEn } from './modules/analytics.en';
import { stripeConnectEn } from './modules/stripeConnect.en';
import { campaignEn } from './modules/campaign.en';
import { method } from 'lodash';

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to I.Dpro@gmail.com.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2: `menu level 2`,
  menu_level_3: `menu level 3`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  create_event: 'Create an event',
  label_Rows_Per_Page: 'Rows per page',
  created_At: 'Created at',
  location: 'Location',
  title: 'title',
  events: 'Events',
  archived: 'Archived',
  canceled: 'canceled',
  Start_Date: 'Event start date',
  End_Date: 'Event end date',
  organisation: 'Organisation',
  organisations: 'Organisations',
  published_events: 'Published events',
  Add_event: 'Add Event',
  event_name: 'Event Name',
  summary: 'Summary',
  cancel: 'Cancel',
  cancel_successful: 'Invitation canceled',
  cancel_failed: 'Unable to cancel invitation',
  add: 'Add',
  artists_lineup: 'Artists lineup',
  pass_culture: 'Pass Culture',
  view_event: 'View Event ',
  event_title: 'Event Title',
  cover: 'Cover',
  cover_image: 'Cover Image',
  category: 'Category',
  sub_category: 'Sub Category',
  status: 'Status',
  listed: 'Public event',
  listed_tooltip:
    'When enabled, your event will be publicly visible and searchable by anyone in the event listings',
  online_event: 'Online Event',
  tags: 'Tags',
  address: 'Address',
  city: 'City',
  capacity: 'Capacity',
  save: 'Save',
  Start_Time: 'Event start Time',
  End_Time: 'Event end Time',
  timezone: 'Timezone',
  Save_Changes: 'Save Changes',
  Quantity: 'Quantity',
  Initial_Quantity: 'Available Quantity',
  Max_Quantity: 'Max per order',
  price: 'Price',
  free: 'Free',
  Sell_Time_Limit: 'Sell Time Limit',
  delete: 'Delete',
  Edit: 'Edit',
  Add_Ticket: 'Add Ticket',
  Sell_limit: 'Sell limit',
  start: 'Start',
  end: 'End',
  Access_Time_Limit: 'Event access time',
  Price_Quantity: 'Price and Quantity',
  Access_limit: 'Access limit',
  name: 'Name',
  Include_Platform_Fees: 'Include Platform Fees',
  Final_Price: 'Final Price',
  Platform_Fee_Info:
    'When enabled, the platform commission of 2.5% will be added to the ticket price and paid by the attendees. If disabled, you will be charged this commission from your ticket revenue.',
  Your_event_is_already_published_on_this_link: 'Your event is already published on this link',
  only_confirmed_tickets_can_be_refunded: 'Only confirmed tickets can be refunded',
  refund_ticket: 'Refund ticket',
  can_only_send_email_for_confirmed_or_validated:
    'Can only send email for confirmed or validated tickets',
  send_confirmation_email: 'Send confirmation email',
  archive: 'Archive',
  Event_Dashboard: 'Event Dashboard',
  Preview_Event: 'Preview Event',
  publish: 'Publish',
  Email_Message: 'Text of the email sent to your event participants',
  Ticket_Message: 'Ticket Message',
  include: 'Include',
  required: 'Required',
  Gender: 'Gender',
  Birthday: 'Birthday',
  HomePhone: 'Home Phone',
  yourEventIs: 'Your event is ',
  date: 'Date',
  events_catering: 'Event and Catering',
  events_catering_description:
    'ID is a platform that allows your customers to buy tickets to attend your events, as well as order their food and drinks digitally at your establishment',
  create_digital_exp: 'Create your digital experience',
  create_digital_exp_description:
    'Customers interact with your brand, your way; you control your digital presence to maximize revenue and profitability.',
  digital_ticketing: 'DIGITAL TICKETING',
  digital_ticketing_title: 'Add your events and sell tickets on our platform.',
  digital_ticketing_description:
    'Each of your clients wishing to participate can click on a link or scan a QR code on the digital or physical flyer of your event; this will direct them to the ID platform where they can select and pay for their ticket.',
  more_questions: 'Do you still have questions?',
  more_questions_description: 'Please describe your case to receive the most accurate advice.',
  who_are_we: {
    who: 'Who',
    are: 'are',
    we: 'we',
    work: 'Working together for',
    futur: 'a better future in events and catering',
  },
  what_is_id: {
    title: 'What is ID?',
    description:
      'ID is a platform that allows your customers to buy tickets to attend your events, as well as order their food and drinks digitally at your establishment.',
  },
  about: {
    vision: 'Our vision: To offer the perfect platform for a better future in events and catering.',
    dream_team: 'DREAM TEAM',
    dream_team_description:
      'ID will provide you with assistance if you encounter any problems. Our support team will respond .A good team is the key. Within a day, and we also have detailed documentation.',
  },
  testimonials: {
    title: 'TESTIMONIALS',
    who: 'Who likes',
    service: ' our service?',
    description:
      "Our goal is to create the perfect platform that will satisfy all our customers in events and catering. That's why we are constantly working on our services to improve them every day by listening to the valuable suggestions that our users share with us.",
  },
  Min_Quantity: 'Min per order',
  save_continue: 'Save and continue',
  continue_later: "Don't save and continue later",
  Link_to_buy_tickets_for_your_event: 'Link to buy tickets for your event',
  back: 'Back',
  Complete_the_details_of_the_event_to_be_able_to_publish_it:
    'Complete the details of the event to be able to publish it',
  publish_the_event: 'Publish the event',
  view: 'View',
  ready_events: 'Ready events',
  drafted_events: 'Drafted events',
  archived_events: 'Archived events',
  canceled_events: 'canceled events',
  no_events: 'No events',
  my_events: 'My promo events',
  total_sold: 'Total revenue',
  sold_quantity: 'Number of tickets sold',
  send_batch_emails: 'Send Batch Emails',
  event_link: 'Event link',
  sale_date: 'Sale date',
  validated: 'Validated',
  confirmed: 'Confirmed',
  reimbursed: 'Reimbursed',

  tickets_in_reservation: 'Tickets in Reservation',
  payment_id: 'Payment ID',
  origin: 'Origin',
  bus_tickets: 'Bus Tickets',
  type: 'Type',
  route: 'Route',
  departure_time: 'Departure Time',
  outbound: 'Outbound',
  return: 'Return',
  not_specified: 'Not specified',
  invalid_date: 'Invalid date',
  total_bus_tickets: 'Total Bus Tickets',
  total_amount: 'Total Amount',
  mixed: 'Mixed',
  sent: 'Sent',
  not_sent: 'Not Sent',
  view_details: 'View Details',

  event_sales_status: 'Event Sales Status',
  event_closed_for_sales: 'This event is currently closed for sales',
  event_open_for_sales: 'This event is open for sales',
  open_sales: 'Open Sales',
  close_sales: 'Close Sales',
  confirm_open_sales: 'Confirm Opening Sales',
  confirm_close_sales: 'Confirm Closing Sales',
  open_sales_confirmation_message:
    'Are you sure you want to open sales for this event? This will allow users to make new reservations.',
  close_sales_confirmation_message:
    'Are you sure you want to close sales for this event? This will prevent users from making new reservations.',
  event_closed_warning:
    'Sales are currently closed for this event. No new reservations can be made until sales are reopened.',
  export_tickets: 'Export Tickets',
  select_statuses_to_export: 'Select ticket statuses to export',
  total_selected_tickets: 'Total selected tickets',
  please_select_at_least_one_status: 'Please select at least one status to export',
  no_tickets_found_for_selected_statuses: 'No tickets found for the selected statuses',
  export_error: 'An error occurred during export',
  exporting: 'Exporting...',
  preordered: 'Preordered',
  refunded: 'Refunded',
  About: 'About',
  Name: 'Name',
  promoters: 'Promoboosters',
  add_promoter: 'Add PromoBooster',
  choose_promoter: 'Choose PromoBooster',
  remove: 'Remove',
  min_followers: 'Minimun followers',
  Dashboard: 'Dashboard',
  General: 'General',
  Preview: 'Preview',
  required_information: 'Required information',
  promo_code: 'Promo codes',
  email_campaigns: 'Email Campaigns',
  campaign_tracking: 'Campaign Tracking',
  overview: 'Overview',
  preview_your_event: 'Preview your event',
  Owner: 'Owner',
  create_org: 'Create an organisation',
  Account: 'Account',
  account_settings: 'Account settings',
  Allowed_format: 'Allowed formats',
  max_size: 'max size of',
  billing: 'billing',
  Email_Address: 'Email address',
  Phone_Number: 'Phone number',
  Country: 'Country',
  State_Region: 'State/Region',
  Zip_Code: 'Zip/Code',
  discount: 'Discount',
  maximum_number_of_sold_tickets: 'maximum number of sold tickets',
  Featured_tickets: 'Featured tickets',
  No_promo_code_available: 'No promo code available',
  add_promo_code: 'Add promo code',
  This_code_is_already_used: 'This code is already used!',
  discount_amount: 'Discount amount',
  advanced_options: 'Advanced options',
  all_tickets: 'All tickets',
  specific_tickets: 'Specific tickets',
  Legal_info: 'Legal information',
  Followers: 'Followers',
  Total_events: 'Total events',
  Recommended: 'Recommended',
  company_name: 'Company name',
  company_number: 'Company number',
  Website: 'Website',
  Cover: 'Cover',
  add_organisation: 'Add organisation',
  create_user: 'create user',
  users: 'users',
  firstname: 'First Name',
  lastname: 'Last Name',
  role: 'Role',
  access: 'access',
  events_permissions: 'Events permissions',
  organisations_permissions: 'Organisations permissions',
  Yes: 'Yes',
  No: 'No',
  Permissions: 'Permissions',
  Editing: 'Editing',
  Roles: 'Roles',
  Search: 'Search',
  Event_stats: 'Event stats',
  sales: 'sales',
  Number_of_purchase: 'Number of purchases',
  Link: 'Link',
  sold: 'sold',
  available: 'available',
  Tickets_status: 'Tickets status',
  There_is_no_tickets_status_for_this_event: 'There is no tickets status for this event',
  promoter: 'Promoter',
  invite_user: 'Invite user',
  published: 'Published',
  ready: 'Ready',
  draft: 'Draft',
  initial: 'initial',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  past: 'past',
  Organisation: 'Organisation',
  Bio: 'Bio',
  Type: 'Type',
  Evenementiel: 'Events',
  Restaurant: 'Restaurant',
  'Music Studio': 'Music Studio',
  'Create Your Music Studio': 'Create Your Music Studio',
  'Set up your recording studio with professional features':
    'Set up your recording studio with professional features',
  'Your music studio is ready to start accepting bookings!':
    'Your music studio is ready to start accepting bookings!',
  'Studio Name': 'Studio Name',
  'Studio Description': 'Studio Description',
  'Studio Address': 'Studio Address',
  'Create Music Studio': 'Create Music Studio',
  'Create your recording studio with professional booking and management features':
    'Create your recording studio with professional booking and management features',
  'Enter the full address of your music studio': 'Enter the full address of your music studio',
  'Contact Information': 'Contact Information',
  'Help clients find and contact your studio': 'Help clients find and contact your studio',
  'Additional Contact Information': 'Additional Contact Information',
  Optional: 'Optional',
  'Studio Features & Services': 'Studio Features & Services',
  'Choose the features and services for your studio':
    'Choose the features and services for your studio',
  'Studio Management Features': 'Studio Management Features',
  'Required features are automatically enabled and cannot be disabled':
    'Required features are automatically enabled and cannot be disabled',
  'Services Offered': 'Services Offered',
  'Select the services your studio provides to clients':
    'Select the services your studio provides to clients',
  'Selection Summary': 'Selection Summary',
  'Enabled Features': 'Enabled Features',
  'Availability & Booking Settings': 'Availability & Booking Settings',
  'Configure when your studio is available for bookings':
    'Configure when your studio is available for bookings',
  'Basic Booking Settings': 'Basic Booking Settings',
  'Time Slot Duration': 'Time Slot Duration',
  'Select duration': 'Select duration',
  'Advance Booking (Days)': 'Advance Booking (Days)',
  'How far in advance can clients book?': 'How far in advance can clients book?',
  'Minimum Notice (Hours)': 'Minimum Notice (Hours)',
  'Minimum hours notice required for booking': 'Minimum hours notice required for booking',
  'Maximum Booking Duration (Minutes)': 'Maximum Booking Duration (Minutes)',
  'Maximum session length': 'Maximum session length',
  'Buffer Time (Minutes)': 'Buffer Time (Minutes)',
  'Break time between sessions': 'Break time between sessions',
  'Auto-approve bookings': 'Auto-approve bookings',
  'Allow back-to-back bookings': 'Allow back-to-back bookings',
  'Working Hours': 'Working Hours',
  'Advanced Settings': 'Advanced Settings',
  'These settings enable cross-day bookings for long recording sessions':
    'These settings enable cross-day bookings for long recording sessions',
  'Enable cross-day bookings': 'Enable cross-day bookings',
  'Maximum Cross-Day Hours': 'Maximum Cross-Day Hours',
  'Maximum hours a session can extend into the next day':
    'Maximum hours a session can extend into the next day',
  'Allow weekend crossover': 'Allow weekend crossover',
  'Require same-day start': 'Require same-day start',
  'Creating your music studio...': 'Creating your music studio...',
  'Please wait while we set up your studio with all the selected features.':
    'Please wait while we set up your studio with all the selected features.',
  'This may take a few moments.': 'This may take a few moments.',
  'Set up your professional recording studio with comprehensive booking and management features':
    'Set up your professional recording studio with comprehensive booking and management features',
  'Quick setup with essential features pre-configured for immediate use':
    'Quick setup with essential features pre-configured for immediate use',
  'Enter your music studio name': 'Enter your music studio name',
  'Describe your music studio services and specialties':
    'Describe your music studio services and specialties',
  'Upload a cover image that represents your studio':
    'Upload a cover image that represents your studio',
  Open: 'Open',
  Closed: 'Closed',
  Back: 'Back',
  Required: 'Required',
  // Studio Business Settings
  'Studio Business': 'Studio Business',
  'Studio Visibility': 'Studio Visibility',
  'Control whether your studio appears in public listings and search results':
    'Control whether your studio appears in public listings and search results',
  'Publicly Visible': 'Publicly Visible',
  'Your studio appears in public listings and can be found by clients':
    'Your studio appears in public listings and can be found by clients',
  'Your studio is hidden from public view and only accessible by direct link':
    'Your studio is hidden from public view and only accessible by direct link',
  'Accept Bookings': 'Accept Bookings',
  'Your studio is accepting new booking requests': 'Your studio is accepting new booking requests',
  'New bookings are temporarily disabled': 'New bookings are temporarily disabled',
  'Music Styles & Genres': 'Music Styles & Genres',
  'Add music styles and genres you specialize in to help clients find you':
    'Add music styles and genres you specialize in to help clients find you',
  'Add music style or genre (e.g., Rock, Jazz, Hip Hop)':
    'Add music style or genre (e.g., Rock, Jazz, Hip Hop)',
  'No music styles added yet. Add some to help clients find your studio.':
    'No music styles added yet. Add some to help clients find your studio.',
  'Save Studio Settings': 'Save Studio Settings',
  // Featured Artists Management
  'Featured Artists': 'Featured Artists',
  'Showcase artists who have worked with your studio (with their consent)':
    'Showcase artists who have worked with your studio (with their consent)',
  'Add Artist': 'Add Artist',
  'Featured Artists Settings': 'Featured Artists Settings',
  'Save Settings': 'Save Settings',
  'Enable Featured Artists': 'Enable Featured Artists',
  'When enabled, featured artists will be visible in the showcase':
    'When enabled, featured artists will be visible in the showcase',
  'Important:': 'Important:',
  'Only add artists who have given explicit consent to be featured. Always respect artist privacy and rights.':
    'Only add artists who have given explicit consent to be featured. Always respect artist privacy and rights.',
  'Enable featured artists above to start showcasing artists who have worked with your studio':
    'Enable featured artists above to start showcasing artists who have worked with your studio',
  'Add First Artist': 'Add First Artist',
  'No featured artists added yet. Add your first artist to get started!':
    'No featured artists added yet. Add your first artist to get started!',
  Hidden: 'Hidden',
  'Consent Given': 'Consent Given',
  'Hide artist': 'Hide artist',
  'Show artist': 'Show artist',
  'Edit artist': 'Edit artist',
  'Remove artist': 'Remove artist',
  'Edit Featured Artist': 'Edit Featured Artist',
  'Add Featured Artist': 'Add Featured Artist',
  'Artist Name': 'Artist Name',
  Genre: 'Genre',
  Description: 'Description',
  'Brief description of the artist or their work with your studio...':
    'Brief description of the artist or their work with your studio...',
  'Website URL': 'Website URL',
  'Instagram URL': 'Instagram URL',
  'Spotify URL': 'Spotify URL',
  'YouTube URL': 'YouTube URL',
  'Invalid website URL': 'Invalid website URL',
  'Invalid Instagram URL': 'Invalid Instagram URL',
  'Invalid Spotify URL': 'Invalid Spotify URL',
  'Invalid YouTube URL': 'Invalid YouTube URL',
  'Artist Photo': 'Artist Photo',
  'I confirm that this artist has given explicit consent to be featured in our studio showcase':
    'I confirm that this artist has given explicit consent to be featured in our studio showcase',
  'This is required for legal and ethical reasons':
    'This is required for legal and ethical reasons',
  'Artist consent is required to showcase their work':
    'Artist consent is required to showcase their work',
  Cancel: 'Cancel',
  Update: 'Update',
  Add: 'Add',
  Artist: 'Artist',
  // Error/Success messages for artist management
  'Failed to load featured artists': 'Failed to load featured artists',
  'Failed to load artists data': 'Failed to load artists data',
  'Featured artists settings saved successfully!': 'Featured artists settings saved successfully!',
  'Failed to save artists settings': 'Failed to save artists settings',
  'Photo uploaded successfully!': 'Photo uploaded successfully!',
  'Failed to upload photo': 'Failed to upload photo',
  'Please enter an artist name': 'Please enter an artist name',
  'Artist updated successfully!': 'Artist updated successfully!',
  'Artist added successfully!': 'Artist added successfully!',
  'Failed to save artist': 'Failed to save artist',
  'Artist removed successfully!': 'Artist removed successfully!',
  'Failed to remove artist': 'Failed to remove artist',
  'Artist visibility updated!': 'Artist visibility updated!',
  'Failed to update artist visibility': 'Failed to update artist visibility',
  'Failed to save new order': 'Failed to save new order',
  // Music Genres for Featured Artists
  Pop: 'Pop',
  Rock: 'Rock',
  'Hip Hop': 'Hip Hop',
  Electronic: 'Electronic',
  Jazz: 'Jazz',
  Classical: 'Classical',
  Folk: 'Folk',
  Blues: 'Blues',
  Reggae: 'Reggae',
  Punk: 'Punk',
  Metal: 'Metal',
  Indie: 'Indie',
  'World Music': 'World Music',
  Experimental: 'Experimental',
  Other: 'Other',
  // ManageAvailability Component
  'Studio Availability': 'Studio Availability',
  'Configure your studio working hours, booking time slots, and availability rules':
    'Configure your studio working hours, booking time slots, and availability rules',
  'Booking Rules': 'Booking Rules',
  'Time Slots': 'Time Slots',
  'Weekly Schedule': 'Weekly Schedule',
  'Set your studio operating hours for each day of the week. Enable 24-hour mode or set cross-midnight schedules (e.g., 22:00 to 06:00 next day)':
    'Set your studio operating hours for each day of the week. Enable 24-hour mode or set cross-midnight schedules (e.g., 22:00 to 06:00 next day)',
  'Cross-Day Booking Policy': 'Cross-Day Booking Policy',
  'Enable Cross-Day Bookings': 'Enable Cross-Day Bookings',
  'Allow bookings that span across midnight (e.g., 23:00 PM to 2:00 AM)':
    'Allow bookings that span across midnight (e.g., 23:00 PM to 2:00 AM)',
  'Max Cross-Day Hours': 'Max Cross-Day Hours',
  'Maximum hours a booking can span across days': 'Maximum hours a booking can span across days',
  'Allow Weekend Crossover': 'Allow Weekend Crossover',
  'Allow bookings to cross from weekend to weekday or vice versa':
    'Allow bookings to cross from weekend to weekday or vice versa',
  'Require Same Day Start': 'Require Same Day Start',
  'Booking must start and end on the same calendar day':
    'Booking must start and end on the same calendar day',
  '24h': '24h',
  'Start Time': 'Start Time',
  'End Time': 'End Time',
  'Next day': 'Next day',
  'Cross-midnight schedule:': 'Cross-midnight schedule:',
  'next day': 'next day',
  'Booking Configuration': 'Booking Configuration',
  'Configure booking rules and restrictions': 'Configure booking rules and restrictions',
  'Advance Booking Days': 'Advance Booking Days',
  'How many days in advance can clients book': 'How many days in advance can clients book',
  'Minimum Notice (hours)': 'Minimum Notice (hours)',
  'Minimum hours before booking': 'Minimum hours before booking',
  'Max Session Duration (minutes)': 'Max Session Duration (minutes)',
  'Maximum booking duration': 'Maximum booking duration',
  'Buffer Time (minutes)': 'Buffer Time (minutes)',
  'Break time between bookings': 'Break time between bookings',
  'Automatically approve booking requests without manual review':
    'Automatically approve booking requests without manual review',
  'Allow bookings to be scheduled consecutively': 'Allow bookings to be scheduled consecutively',
  'Time Slot Configuration': 'Time Slot Configuration',
  'Configure booking time slots and intervals': 'Configure booking time slots and intervals',
  'Time Slot Unit': 'Time Slot Unit',
  'Default Slot Duration (minutes)': 'Default Slot Duration (minutes)',
  'Default duration for booking slots': 'Default duration for booking slots',
  'Time slots will be generated based on your working hours and selected time unit. Clients can select from available slots when booking.':
    'Time slots will be generated based on your working hours and selected time unit. Clients can select from available slots when booking.',
  Reset: 'Reset',
  'Loading availability settings...': 'Loading availability settings...',
  'Failed to load availability settings. Please try refreshing the page.':
    'Failed to load availability settings. Please try refreshing the page.',
  'Availability settings saved successfully!': 'Availability settings saved successfully!',
  'An error occurred. Please try again.': 'An error occurred. Please try again.',
  // Form validation messages for availability
  'Advance booking days is required': 'Advance booking days is required',
  'Minimum booking notice is required': 'Minimum booking notice is required',
  'Maximum booking duration is required': 'Maximum booking duration is required',
  'Time slot duration is required': 'Time slot duration is required',
  'Buffer time is required': 'Buffer time is required',
  // Time units
  '15 minutes': '15 minutes',
  '30 minutes': '30 minutes',
  '1 hour': '1 hour',
  // Days of the week
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  // Studio features
  'Basic Booking System': 'Basic Booking System',
  'Essential booking and scheduling features': 'Essential booking and scheduling features',
  'Availability Management': 'Availability Management',
  'Advanced availability and time slot management':
    'Advanced availability and time slot management',
  'Client Management': 'Client Management',
  'Client profiles and contact information': 'Client profiles and contact information',
  'Equipment Management': 'Equipment Management',
  'Track and manage studio equipment': 'Track and manage studio equipment',
  'Project Management': 'Project Management',
  'Organize recording projects and sessions': 'Organize recording projects and sessions',
  'Music Showcase': 'Music Showcase',
  "Display your studio's work and portfolio": "Display your studio's work and portfolio",
  'Payment Processing': 'Payment Processing',
  'Handle payments and invoicing': 'Handle payments and invoicing',
  'Reporting & Analytics': 'Reporting & Analytics',
  'Business insights and performance metrics': 'Business insights and performance metrics',
  'Staff Management': 'Staff Management',
  'Manage studio staff and roles': 'Manage studio staff and roles',
  'Multi-Room Support': 'Multi-Room Support',
  'Manage multiple recording rooms': 'Manage multiple recording rooms',
  // Studio services
  Recording: 'Recording',
  Mixing: 'Mixing',
  Mastering: 'Mastering',
  'Music Production': 'Music Production',
  Composition: 'Composition',
  'Voice Over': 'Voice Over',
  'Podcast Recording': 'Podcast Recording',
  'Live Streaming': 'Live Streaming',
  'Instrument Rental': 'Instrument Rental',
  'Music Lessons': 'Music Lessons',
  Email: 'Email',
  Drop_or_Select_file: 'Drop or select a file',
  Rajoutez_une_image_de_couverture_pour_votre_événement: 'Add a cover image for your event',
  Upload_photo: 'Upload photo',
  Update_photo: 'Update photo',
  organisation_users: 'Organisation users',
  Agent_liés_à_lorganisation: 'Agents related to the organization',
  Agents_en_attente_de_confirmation: 'Agents awaiting confirmation',
  Instadrink_admin: 'I.D Admin',
  create_role: 'Create a role',
  Predefined_roles: 'Predefined roles',
  Custom_roles: 'Custom roles',
  Agents: 'Agents',
  Organizer: 'Organizer',
  Bouncer: 'Bouncer',
  Ambassador: 'Ambassador',
  promotion_groups: 'PromoBoosters groups',
  Dates: 'Dates',
  Tickets: 'Tickets',
  Messages: 'Messages',
  Promotion: 'Promotion',
  Participants: 'Participants',
  Client: 'Client',
  description_placeholder:
    'Describe to your future participants the exceptional atmosphere that will prevail at your event.',
  Tickets_collection: 'Tickets collection',
  Stop_sell_time_is_at: 'Stop sell time is at',
  drag_and_drop: 'drag and drop to change the order',
  delete_ticket_confirmation: 'Are you sure you want to delete this ticket?',
  Access_Time_Thresholdt: 'Event access end time',
  order: 'order',
  Créez_les_tickets_pour_votre_événement: 'Create tickets for your event',
  stop_sell_time_error_message:
    'End date must be later than start date and not exceed the stop sell date',
  send_invitation: 'Send invitation',
  Tickets_quantity_error_message: 'places are remaining',
  Write_something_awesome: 'Write something awesome...',
  Code: 'Code',
  delete_promocode_confirm_message: 'Are you sure you want to delete this code?',
  Activate_promotion: 'Activate promotion',
  Desactivate_promotion: 'Disable promotion',
  Configure_RP_offer: 'Configure the PromoBooster offer',
  promotion_status: 'promotion status',
  TooltipTextForPromotionGroups:
    'In this section you can create and manage Resource Persons (RPs) groups for your events',
  TooltipTextForEventLink: 'Publish your event to get your event link',
  TooltipTextForPromotionGroupsForReferral:
    'In this section, you will find the PromoBooster groups that you are a member of, and you can leave the group whenever you want.',
  confirm_delete_promoter: 'Are you sure you want to delete this PromoBooster?',
  Preview_promoter_link: "Preview PromoBooster's link",
  Locked: 'Locked',
  pending: 'pending',
  accepted: 'accepted',
  rejected: 'rejected',
  Publish_my_event_now: 'Publish my event now',
  publish_later: 'Publish later',
  Your_event_is_still_draft:
    'Your event is still a draft, complete the configuration to publish it',
  Are_you_sure_to_publish_the_event: 'Are you sure to publish the event  ',
  pourcentage: 'pourcentage',
  Rate: 'Rate',
  Message: 'Message',
  submit: 'submit',
  Create_group: 'Create group',
  Groups: 'Groups',
  Edit_group: 'Edit group',
  Search_by_Name: 'Search by name',
  Enter_group_name: 'Enter group name',
  No_promoters_found: 'No promoters found',
  Add_group: 'Add group',
  Number_of_sales: 'Number of sales',
  Turnover: 'Turnover',
  Number_of_clients: 'Number of clients',
  Promotion_requests: 'Promotion requests',
  Requests: 'Requests',
  Notifications: 'Notifications',
  Referral_requests: 'PromoBooster requests',
  no_requests: 'There is no requests',
  request_message: 'sent you a request to invite you to be the PromoBooster of',
  Accept: 'Accept',
  Reject: 'Reject',
  Your_invitation_to: 'Your invitation to',
  on: 'on',
  at: 'at',
  is: 'is',
  promotion_rate: 'promotion rate',
  consigne: 'order',
  Cancel_request: 'Cancel request',
  Send_request: 'Send request',
  No_events: 'Find an event you would like to collaborate as an PromoBooster',
  Search_for_new_events: 'Search for new events',
  Search_for_Events: 'Search for events',
  Sales_stats: 'Sales stats',
  Total_sales: 'Total sales',
  Total_reservation: 'Total reservations',
  Bienvenue_message: 'Welcome to I.D, choose your domain',
  second_bienvenu_message: 'Welcome to I.D, select your industry between events and catering.',
  Continue: 'Continue',
  Event: 'Event',
  orga_message: 'Choose the organization under which you will create your event',
  Skip: 'Skip',
  All_steps_completed: 'All steps completed',
  you_have_finished: 'you have finished',
  limit_sell_message: 'Enter a limit date and time for the tickets sale',
  stopSellDate: 'Tickets stop sell date',
  status_tooltip:
    'This status field calculate automatically the the start date and the end date and give you the event status',
  Step: 'Step',
  correct_start_date: 'Correct the past start date',
  Finish: 'Finish',
  event_name_tooltip: 'What is the name of your event?',
  event_summary_tooltip:
    'Give a glimpse of the beautiful surprises awaiting future participants at your event.',
  event_description_tooltip:
    'This time, describe in detail the event that future participants will have the chance to attend.',
  event_cover_tooltip: 'Choose a photo for your event.',
  organisation_tooltip: 'Choose the name of the organization that will host your event.',
  category_tooltip: 'Select a category for your event.',
  subCategory_tooltip: 'Choose a sub-category for your event.',
  Rp_request: 'sent you request to be the PromoBooster of his event',
  warning_message: 'Please press "add" first to save your ticket and continue',
  correct_date_tooltip: 'The selected start date for your event has already passed.',
  step1: 'In this step, you will find the event sales stats and the attendees list for the event.',
  step2: 'In this step, you can edit the event details.',
  step3: 'In this step, you can edit the event dates and times.',
  step4: 'In this step, you can add new tickets for your event or edit the existing tickets.',
  step5: 'In this step, you can publish or archive your event.',
  step6: 'In this step, you find the event view for clients in the desktop view or mobile view.',
  step7: 'In this step, you will find the overview of your event details.',
  step8: 'In this step, you can information about the event.',
  stepCodePromo: 'In this step, you can add promo codes for the tickets.',
  step10:
    'In this step, you can manage the RPs for your event, create a group of RPs, or send requests for the PromoBooster to be a PromoBooster of your event.',
  step11: 'In this step, you will find the list of attendees.',
  total_sold_tooltip: 'This is the total sale price for the event tickets',
  sold_quantity_tooltip: 'This is the total sale quantity for event the tickets',
  link_tooltip: 'This is the event link to purchase your tickets.',
  table_tooltip: 'Here is the table where you find the list of the attendees for this event.',
  create_event_button_tooltip: 'Click here to create a new event.',
  events_table_tooltip: 'This is the events table where you can find your events details.',
  You_have_no_organisations: 'You have no organisations',
  alert_orga_title: 'You have to create an organisation so you can create an event after.',
  Configurate_here: 'Configurate here',
  legal_verification: 'Legal verification of your account',
  alert_stripe_configuration_title:
    'Please complete your legal information to activate your account and be able to sell your tickets.',
  Bank_balance: 'Bank balance',
  View_my_Stripe_account: 'View my Stripe account',
  Your_balance: 'Your balance',
  Add_new_card: 'Add new card',
  Name_on_card: 'Name on card',
  Card_number: 'Card number',
  Expiration_date: 'Expiration date',
  QRcode_tooltip: 'Click here to customize and download the QR code of your event',
  File_Type: 'File type',
  Size: 'Size',
  Color: 'Color',
  Background_Color: 'Background color',
  Download_QR_Code: 'Download QR Code',
  Download_Invoice: 'Download invoice',
  show_qr_code: 'Show QR code',
  Close: 'Close',
  Customize_QR_Code: 'Customize QR Code',
  no_users_yet: 'No users yet',
  plz_invite_users: 'Please invite users',
  invite_organizer: 'Invite organizer',
  invite: 'invite',
  settings: 'settings',
  invite_owners: 'invite owners',
  register: 'Register',
  password: 'Password',
  confirm_password: 'Confirm Password',
  email_adress: 'Email Address',
  division_agent: 'Agent',
  division_promoter: 'Promoter',
  iam_owner: 'I am an Owner',
  iam_owner_desc: 'Manage your organizations, restaurants, and events',
  iam_amb: 'I am an Ambassador',
  iam_amb_desc: 'Promote organizations and earn commissions',
  iam_ref: 'I am an PromoBooster',
  iam_ref_desc: 'Refer events and earn commissions',
  start_free: 'Start for Free',
  no_credit_card: 'No Credit Card Required',
  have_account: 'Already have an account?',
  by_register_1: 'By registering, I agree to I.D ',
  by_register_2: 'Terms of Service',
  by_register_3: ' and ',
  by_register_4: 'Privacy Policy.',
  manager_better_register: 'Manage events more efficiently with I.D',
  referral: 'PromoBooster',
  first_name_required: 'First name required',
  first_name_short: 'First name is too short - should be 3 chars minimum.',
  first_name_long: 'First name is too long - should be 50 chars maximum.',
  first_name_alpha: 'First name can only contain alphabetic characters.',
  last_name_required: 'Last name required',
  last_name_short: 'Last name is too short - should be 3 chars minimum.',
  last_name_long: 'Last name is too long - should be 50 chars maximum.',
  last_name_alpha: 'Last name can only contain alphabetic characters.',
  email_invalid: 'Email must be a valid email address',
  email_required: 'Email is required',
  password_required: 'Password is required',
  password_short: 'Password is too short - should be 8 chars minimum.',
  password_long: 'Password is too long - should be 128 chars maximum.',
  password_alpha: 'Password can only contain Latin letters.',
  password_lowercase: 'Password must contain at least one lowercase letter.',
  password_uppercase: 'Password must contain at least one uppercase letter.',
  password_number: 'Password must contain a number.',
  password_special: 'Password must contain at least one special character.',
  password_no_repeat: 'Password must not repeat the same character three times in a row.',
  confirm_password_match: 'Passwords must match',
  confirm_password_required: 'Confirm Password is required',
  division_required: 'Division is required',
  division_invalid: 'Division must be either Promoter or Agent',
  role_required: 'Role is required',
  role_invalid_promoter: 'Invalid role for Promoter',
  role_invalid_agent: 'Invalid role for Agent',
  login: 'Login',
  fr: 'Français',
  en: 'English',
  es: 'Espagnol',
  pt: 'Portugais',
  lang: 'Language',
  creating_account: 'Account Creation in Progress',
  creating_account_desc: 'Finalizing Your Account Setup',
  creating_account_info:
    'Your account is currently being set up. Please remain on this page until the process is complete. We appreciate your patience!',
  accept_invitation_info:
    'Please note, after accepting the invitation below, you will receive a verification email. Following the verification, you will be able to complete your account setup, including the options to change your name and preferred language.',
  invitation_already_processed:
    'This invitation has already been processed. Please check your events dashboard for more information.',
  'invitation.continuation_title': 'Invitation Already Sent!',
  'invitation.continuation_body':
    'An invitation for this email is already on the way. Please check your inbox (and spam folder) and click on the verification link.\n\nIf the email cannot be found, you can continue by tapping the <0>Re-invite</0> button.',
  'invitation.continuation_use_existing': "I'll check my email",
  'invitation.continuation_start_new': 'Re-invite',
  verify_email: 'Verify Your Email',
  verify_email_desc: 'Account Successfully Created',
  account_created_check_email:
    'Account created successfully. Please check your email to verify your account and gain full access.',
  thanks_join_invite: 'Thank you for joining our community!',
  verify_before_expire: 'Verify your mail before it expires',
  verify_email_info:
    'Congratulations on setting up your account! Please check your email inbox to verify your account and gain full access.',
  wait_verify: 'Please wait a moment while we verify your email.',
  wait_redirect: 'Do not close this window until you have been redirected to the dashboard.',
  initialAccountHeader: 'Finalize Your I.D Account',
  initialAccountDescription:
    'Welcome back! Just set your password below to finalize your account setup.',
  initialAccountButton: 'Complete Setup',
  processingAccountHeader: 'Setting Up Your Account...',
  processingAccountDescription:
    'Please wait a moment while we confirm your details and secure your account.',
  processingAccountButton: 'Completing...',
  successAccountHeader: 'Success! Account Ready',
  successAccountDescription:
    "Your account has been successfully set up, and you're being signed in. You will be redirected to the dashboard shortly.",
  successAccountButton: 'Redirecting...',
  errorAccountHeader: 'Something Went Wrong',
  errorAccountDescription:
    'There was an issue with your account setup. The link may be invalid or expired, or the email address may be incorrect.',
  errorAccountButton: 'Try Again',
  linkexpiredAccountHeader: 'Check Your Email',
  linkexpiredAccountDescription:
    'There was a problem with setting up your account. The link might be invalid or expired, or the email address could be incorrect.',
  verification_expired: 'Account setup failed! The verification link for your account has expired.',
  new_verification_link_sent: 'A new verification link has been sent to your email address.',
  login_welcome: 'Hi, Welcome',
  login_connect: 'Log in to I.D',
  login_type: 'Enter your details below.',
  login_no_account: "Don't have an account?",
  login_register: 'Sign Up',
  owner_total_part: 'This is the owner shares for the event tickets sales.',
  my_share: 'My share',
  Remember_password: 'Remember password',
  forgot_password: 'Forgot your password?',
  create_your_first_organization: 'Create your first organization',
  create_organization_step_description:
    'To start managing your events. Create your first organization. You can create as many organizations as you want later.',
  create_your_first_event: 'Create your first event',
  create_event_step_description:
    "Now that you've created your first organization, it's time to briefly create your first event. You can edit it in detail later.",
  congratulations: 'Congratulations !',
  last_step_description: 'You can now navigate to the events list and continue creating your event',
  create_your_first_restaurant: 'Create your first restaurant',
  create_restaurant_step_description:
    'To start managing your tables. Create your first restaurant. You can create as many restaurants as you want later.',
  create_restaurant_last_step_description:
    'You can now navigate to the restaurant list and continue creating your tables',
  Logout: 'Logout',
  Settings: 'Settings',
  create_store: 'Create store',
  add_category: 'Add Category',
  add_new_product: 'Add new product',
  add_new_category: 'Add new category',
  products: 'Products',
  categories: 'Categoies',
  unavailable: 'Unavailable',
  composite: 'Composite',
  alcoholic: 'Alcoholic',
  Available: 'Available',
  simple: 'Simple',
  search_product: 'Search product...',
  min_price: 'Minimum price',
  max_price: 'Maximum price',
  add_product: 'Add product',
  edit_product: 'Edit product',
  product_details: 'Product details',
  composition_items: 'Composition items',
  caption: 'Caption',
  extra: 'Extra',
  max_quantity: 'Max quantity',
  add_composition: 'Add composition',
  items: 'Items',
  item_name: 'item name',
  add_item: 'Add item',
  preparation_time: 'Preparation Time',
  Orders: 'Orders',
  current_orders: 'Current Orders',
  store: 'Store',
  no_stores_message: 'You have no stores to see orders, please create one first',
  Pending: 'Pending',
  in_preparation: 'In Preparation',
  Preparation: 'Preparation',
  accept_order: 'Accept order',
  order_is_ready: 'Order is ready',
  finish_order: 'Finish order',
  total: 'Total',
  order_of: 'Order of',
  Contact: 'Contact',
  reservations_shares: 'Reservations shares',
  client_name: 'Client name',
  owner_share: 'Owner share',
  instadrink_share: 'I.D share',
  rp_share: 'PromoBooster share',
  ambassador_share: 'Ambassador share',
  shares_distribution: 'Shares distribution',
  group_name: 'Group name',
  group_members: 'Group members',
  created_by: 'Created by',
  leave_group: 'Leave group',
  with_product: 'With product',
  all_categories: 'All categories',
  inclusives: 'Inclusives',
  closing_Time: 'closing time',
  open: 'Open',
  Rush_hour: 'Rush hour',
  preview_store: 'Preview store',
  Delete_account: 'Delete account',
  Are_you_sure_you_want_to_delete_your_account: 'Are you sure you want to delete your account',
  delete_account_page_message:
    ' By choosing to delete your account, you are opting for the permanent removal of all your data from our system.',
  restaurants: 'Restaurants',
  network: 'Network',
  stores: 'Stores',
  commandes: 'Commandes',
  applications: 'Applications',
  inviteUsers: 'Invite Users',
  inviteAgents: 'Invite Agents',
  inviteStaff: 'Invite Staff',
  invitationsList: 'Invitations list',
  promotersTree: 'Invitations tree',
  promotionGroups: 'PromoBoosters Groups',
  onboarding: 'Onboarding',

  // Enhanced Organization Onboarding
  enhanced_organization: {
    address_requires_coordinates: 'Please select a valid address from suggestions',

    // Step Labels
    step_labels: {
      basic: 'Basic Information',
      contact: 'Contact Information',
      type: 'Organization Type',
      roles: 'Staff Roles',
      staff: 'Team Members',
      features: 'Features & Settings',
      availability: 'Availability & Hours',
      showcase: 'Music Showcase',
      quick_setup: 'Quick Setup',
    },

    // Dialog Title and General
    create_organization: 'Create Organization',
    step: 'Step',
    of: 'of',
    quick_mode: 'Quick Mode',
    quick_setup: 'Quick Setup',
    music_studio: 'Music Studio',

    // Basic Information Step
    tell_us_about_organization: 'Tell us about your organization',
    basic_info_subtitle: "Let's start with the basic information",
    organization_name: 'Organization Name',
    organization_name_required: 'Organization Name *',
    organization_name_exists: 'Organization name already exists',
    description: 'Description',
    description_required: 'Description *',
    language: 'Language',
    organization_logo: 'Organization Logo',
    upload_logo: 'Upload Logo',
    cover_image: 'Cover Image',
    upload_cover_image: 'Upload Cover Image',
    change_logo: 'Change Logo',

    // Quick Mode
    quick_setup_mode: 'Quick Setup Mode',
    using_quick_setup: 'Using quick setup with defaults - switch off for detailed configuration',
    skip_detailed_setup:
      'Skip detailed setup and use defaults. You can configure everything later.',
    detailed_setup: 'Detailed Setup',

    // Contact Information Step
    contact_information: 'Contact Information',
    contact_info_subtitle: 'Provide your studio contact details and address',
    email_address: 'Email Address',
    main_contact_email: 'Main contact email for the studio',
    phone_number: 'Phone Number',
    contact_phone_number: 'Contact phone number',
    website: 'Website',
    studio_website_optional: 'Your studio website (optional)',
    studio_address: 'Studio Address',
    full_address_location: 'Full address where your studio is located',
    location_verified: 'Location verified',
    no_locations_found: 'No locations found',
    contact_info_help:
      'Contact information helps clients find and reach your studio. You can update these details later in the settings.',

    // Type Selection Step
    creating_music_studio: 'Creating a Music Studio',
    creating_studio_subtitle:
      'You are creating a recording studio organization with enhanced features',
    what_type_organization: 'What type of organization is this?',
    type_selection_subtitle: 'This helps us customize the experience for you',
    existing: 'Existing',

    // Roles Setup Step
    set_up_staff_roles: 'Set up staff roles',
    roles_setup_subtitle: 'Define roles for your team members. You can skip this step.',
    use_recommended_roles: 'Use recommended roles for this organization type',
    recommended_roles: 'Recommended Roles',
    custom_roles: 'Custom Roles',
    role_name: 'Role Name',

    // Staff Setup Step
    add_team_members: 'Add team members',
    staff_setup_subtitle: 'Add your team members. You can always add more later.',
    add_staff_member: 'Add Staff Member',
    add_new_staff_member: 'Add New Staff Member',
    name: 'Name',
    name_required: 'Name *',
    email: 'Email',
    email_required: 'Email *',
    password: 'Password',
    leave_empty_default: 'Leave empty for default (123)',
    role: 'Role',
    cancel: 'Cancel',
    add_member: 'Add Member',
    added_staff_members: 'Added Staff Members',
    custom_role: 'Custom Role',

    // Availability Setup Step
    studio_availability: 'Studio Availability',
    availability_subtitle:
      'Configure your studio working hours, booking time slots, and availability rules',
    please_fix_issues: 'Please fix the following issues:',
    working_hours: 'Working Hours',
    booking_rules: 'Booking Rules',
    time_slots: 'Time Slots',
    weekly_schedule: 'Weekly Schedule',
    weekly_schedule_subtitle:
      'Set your studio operating hours for each day of the week. Enable 24-hour mode or set cross-midnight schedules (e.g., 22:00 to 06:00 next day)',

    // Cross-Day Booking Policy
    cross_day_booking_policy: 'Cross-Day Booking Policy',
    enable_cross_day_bookings: 'Enable Cross-Day Bookings',
    cross_day_help: 'Allow bookings that span across midnight (e.g., 23:00 PM to 2:00 AM)',
    max_cross_day_hours: 'Max Cross-Day Hours',
    max_cross_day_help: 'Maximum hours a booking can span across days',
    allow_weekend_crossover: 'Allow Weekend Crossover',
    weekend_crossover_help: 'Allow bookings to cross from weekend to weekday or vice versa',
    require_same_day_start: 'Require Same Day Start',
    same_day_start_help: 'Booking must start and end on the same calendar day',

    // Days of Week
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',

    // Time Configuration
    start_time: 'Start Time',
    end_time: 'End Time',
    next_day: 'Next day',
    cross_midnight_schedule: 'Cross-midnight schedule:',

    // Booking Configuration
    booking_configuration: 'Booking Configuration',
    booking_config_subtitle: 'Configure booking rules and restrictions',
    advance_booking_days: 'Advance Booking Days',
    advance_booking_help: 'How many days in advance can clients book',
    minimum_notice_hours: 'Minimum Notice (hours)',
    minimum_notice_help: 'Minimum hours before booking',
    max_session_duration: 'Max Session Duration (minutes)',
    max_duration_help: 'Maximum booking duration',
    buffer_time_minutes: 'Buffer Time (minutes)',
    buffer_time_help: 'Break time between bookings',
    auto_approve_bookings: 'Auto-approve bookings',
    auto_approve_help: 'Automatically approve booking requests without manual review',
    allow_back_to_back: 'Allow back-to-back bookings',
    back_to_back_help: 'Allow bookings to be scheduled consecutively',

    // Time Slot Configuration
    time_slot_configuration: 'Time Slot Configuration',
    time_slot_subtitle: 'Configure booking time slots and intervals',
    time_slot_unit: 'Time Slot Unit',
    default_slot_duration: 'Default Slot Duration (minutes)',
    slot_duration_help: 'Default duration for booking slots',
    time_slot_help:
      'Time slots will be generated based on your working hours and selected time unit. Clients can select from available slots when booking.',

    // Actions
    reset_to_defaults: 'Reset to Defaults',
    current_settings_applied: 'Current settings will be applied when you complete the onboarding',
    availability_for_studios:
      'Availability settings are primarily designed for recording studios. You can configure these later in your dashboard if needed.',
    skip_configure_later:
      'You can skip this step and configure availability settings later in your dashboard. These settings help automate your booking process and client experience.',

    // Showcase Setup Step
    music_showcase: 'Music Showcase',
    showcase_subtitle: "Set up a music showcase to display your studio's work to clients",
    enable_music_showcase: 'Enable Music Showcase',
    showcase_enabled_help:
      'When enabled, your music showcase will be visible to clients on your studio profile',
    showcase_title: 'Showcase Title',
    showcase_title_placeholder: 'e.g., Our Latest Productions',
    showcase_description: 'Showcase Description',
    showcase_description_placeholder: 'Describe your music showcase...',
    add_music_tracks_later:
      'You can add music tracks from YouTube, Spotify, SoundCloud, and other platforms after completing the setup.',
    showcase_for_studios:
      'Music showcase is designed specifically for recording studios. This step can be skipped for other organization types.',
    configure_showcase_later:
      "Don't worry, you can always configure your music showcase later in your dashboard.",

    // Quick Setup Step
    quick_setup_title: 'Quick Setup',
    quick_setup_subtitle_studio:
      'Create your music studio with minimal setup. You can customize everything later.',
    quick_setup_subtitle_general:
      'Create your organization with minimal setup. You can customize everything later.',
    contact_email: 'Contact Email',
    contact_phone: 'Contact Phone',
    logo: 'Logo',
    optional: 'Optional',
    studio_description_placeholder:
      'Describe your music studio, specialties, and what makes it unique...',
    organization_description_placeholder: 'Describe your organization and services...',

    // Default Settings Preview
    default_settings_applied: 'Default Settings Applied',
    standard_working_hours: 'Standard working hours',
    basic_booking_settings: 'Basic booking settings',
    default_roles: 'Default roles',
    core_features_enabled: 'Core features enabled',
    standard_availability_settings: 'Standard availability settings',
    basic_notification_preferences: 'Basic notification preferences',
    customize_settings_later: 'All settings can be customized later in your dashboard.',
    changed_your_mind: 'Changed your mind?',
    switch_to_detailed:
      'You can switch to detailed setup to configure roles, staff, features, and availability step by step. Your basic information will be preserved.',

    // Navigation
    back: 'Back',
    skip: 'Skip',
    next: 'Next',
    complete_setup: 'Complete Setup',

    // Validation Messages
    validation: {
      advance_booking_range: 'Advance booking days must be between 1 and 365',
      minimum_notice_positive: 'Minimum booking notice cannot be negative',
      max_duration_minimum: 'Maximum booking duration must be at least 15 minutes',
      slot_duration_minimum: 'Time slot duration must be at least 15 minutes',
      buffer_time_positive: 'Buffer time cannot be negative',
      reset_success: 'Availability settings reset to defaults',
      fix_issues: 'Please fix the following issues:',
      advance_booking_days: 'Advance booking days must be a positive number',
      minimum_notice_hours: 'Minimum notice hours must be a positive number',
      max_session_duration: 'Maximum session duration must be a positive number',
      buffer_time_minutes: 'Buffer time must be a positive number',
      default_slot_duration: 'Default slot duration must be a positive number',
    },

    // Completion Messages
    organization_created_success: 'Organization created successfully!',
    create_organization_failed: 'Failed to create organization',
    user_not_authenticated: 'User not authenticated',

    // Additional Translation Keys for Enhanced UI

    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    time_units: {
      fifteenMinutes: '15 minutes',
      thirtyMinutes: '30 minutes',
      oneHour: '1 hour',
    },
    placeholders: {
      contact_email: 'contact@studio.com',
      contact_phone: '+33 1 23 45 67 89',
    },
    alerts: {
      availability_reset: 'Availability settings reset to defaults',
      studio_availability_note:
        'Availability settings are primarily designed for recording studios. You can configure these later in your dashboard if needed.',
      skip_availability_note:
        'You can skip this step and configure availability settings later in your dashboard. These settings help automate your booking process and client experience.',
    },

    availability: {
      cross_day_description: 'Allow bookings that span across midnight (e.g., 23:00 PM to 2:00 AM)',
      max_cross_day_hours_help: 'Maximum hours a booking can span across days',
      weekend_crossover_help: 'Allow bookings to cross from weekend to weekday or vice versa',
      same_day_start_help: 'Booking must start and end on the same calendar day',
      next_day: 'Next day',
      cross_midnight_schedule: 'Cross-midnight schedule:',
      next_day_suffix: 'next day',
      advance_booking_help: 'How many days in advance can clients book',
      min_notice_help: 'Minimum hours before booking',
      max_duration_help: 'Maximum booking duration',
      buffer_time_help: 'Break time between bookings',
      auto_approve_help: 'Automatically approve booking requests without manual review',
      back_to_back_help: 'Allow bookings to be scheduled consecutively',
      slot_duration_help: 'Default duration for booking slots',
      time_slots_explanation:
        'Time slots will be generated based on your working hours and selected time unit. Clients can select from available slots when booking.',
      settings_apply_note: 'Current settings will be applied when you complete the onboarding',
    },
    tabs: {
      working_hours: 'Working Hours',
      booking_rules: 'Booking Rules',
      time_slots: 'Time Slots',
    },
    sections: {
      weekly_schedule: 'Weekly Schedule',
      weekly_schedule_description:
        'Set your studio operating hours for each day of the week. Enable 24-hour mode or set cross-midnight schedules (e.g., 22:00 to 06:00 next day)',
      cross_day_policy: 'Cross-Day Booking Policy',
      booking_configuration: 'Booking Configuration',
      booking_configuration_description: 'Configure booking rules and restrictions',
      time_slot_configuration: 'Time Slot Configuration',
      time_slot_description: 'Configure booking time slots and intervals',
    },
    controls: {
      enable_cross_day: 'Enable Cross-Day Bookings',
      max_cross_day_hours: 'Max Cross-Day Hours',
      allow_weekend_crossover: 'Allow Weekend Crossover',
      require_same_day_start: 'Require Same Day Start',
      twentyFourHours: '24h',
      start_time: 'Start Time',
      end_time: 'End Time',
      advance_booking_days: 'Advance Booking Days',
      minimum_notice_hours: 'Minimum Notice (hours)',
      max_session_duration: 'Max Session Duration (minutes)',
      buffer_time_minutes: 'Buffer Time (minutes)',
      auto_approve_bookings: 'Auto-approve bookings',
      allow_back_to_back: 'Allow back-to-back bookings',
      time_slot_unit: 'Time Slot Unit',
      default_slot_duration: 'Default Slot Duration (minutes)',
    },
    quick_setup_content: {
      studio_description:
        'Create a professional music studio profile with essential features and settings',
      org_description: 'Create your organization with basic setup and essential features',
      organization_name_required: 'Organization Name *',
      description_required: 'Description *',
      studio_placeholder: 'Describe your recording studio, services, and specialties...',
      org_placeholder: "Describe your organization's services and mission...",
      optional: 'Optional',
      change_logo: 'Change Logo',
      upload_logo: 'Upload Logo',
      default_settings_applied: 'Default Settings Applied',
      detailed_setup: 'Detailed Setup',
      standard_working_hours: 'Standard working hours (9 AM - 6 PM, Monday-Friday)',
      basic_booking_settings: 'Basic booking settings with 1-hour time slots',
      auto_approval: 'Auto-approval enabled for streamlined booking',
      advance_booking: '7 days advance booking window',
      buffer_time: '30-minute buffer time between sessions',
      customize_later_note: 'All settings can be customized later in your dashboard.',
      changed_mind: 'Changed your mind?',
      switch_to_detailed:
        'Switch to detailed setup for full control over your organization configuration.',
    },
    showcase: {
      title: 'Music Showcase',
      description:
        "Showcase your musical works, featured artists, and creative portfolio to attract clients and demonstrate your studio's capabilities",
      enable_showcase: 'Enable Music Showcase',
      visibility_note: "Create a public showcase visible on your organization's profile page",
      title_placeholder: 'My Studio Showcase',
      description_placeholder: 'Describe your music showcase...',
      platform_integration_note:
        'You can later add music from Spotify, SoundCloud, and other platforms through the showcase management interface.',
      studio_specific_note:
        'Music showcases are primarily designed for recording studios and music venues.',
      dashboard_config_note:
        'You can skip this step and configure your music showcase later in your dashboard.',
    },
    buttons: {
      reset_to_defaults: 'Reset to Defaults',
    },
    roles: {
      custom_role: 'Custom Role',
    },
  },
  if_mistake_contact_instadrink: 'If you have a mistake, please contact I.D',
  invitation_rejected: 'Invitation rejected',
  invite_owner: 'I want to invite a owner',
  invite_referrer: 'I want to invite a PromoBooster',
  invite_ambassador: 'I want to invite an ambassador',
  your_organisation_staff: 'Your organisation staff',
  inv_org_desc: 'The organizer of your event',
  inv_bnc_desc: 'The access controller of your event',
  invite_more_staff: 'Invite more staff',
  since: 'Since',
  delete_event_modal: 'Are you sure to delete the event',
  publish_event_modal: 'Are you sure to publish the event',
  cancel_event_modal: 'Are you sure to cancel the event',
  archive_event_modal: 'Are you sure to archive the event',
  duplicate_event: 'Duplicate event',
  duplicate: 'Duplicate',
  reservations: 'Reservations',
  multiple_persons: 'Multiple persons',
  persons_number: 'Number of persons',
  vatRate: 'VAT rate',
  price_TTC: 'Price including tax',
  Occupation: 'Occupation',
  priceHt: 'Price excluding tax',
  promobooster_mode: 'Promobooster mode',
  promo_mode: 'Promo mode',
  Amount: 'Amount',
  Percentage: 'Percentage',
  include_owners: 'Include owners',
  add_anonymous_promoter: 'Add SpyBooster',
  Confirm_Name: 'Confirm name',
  Add_Anonymous_Name: 'Add SpyBooster',
  ask_for_invoice: 'Ask for invoice',
  add_invoice_button: 'Add  ',
  enter_valid_invoice: 'Please enter a valid invoice',
  Compan_Name_Last_Name: 'Company/Name/Last Name',
  tva: 'TVA',
  adresse: 'address',
  postal_code: 'Postal Code ',
  country: 'Country',
  additional_information: 'Additional information',
  invoice_information: 'Billing',
  survey_information: 'Survey',
  know_from_invoice: 'What information do you require from your invoice?',
  know_from_attendees: 'What do you need to know from your attendees?',
  add_invoice: 'Add new field',
  active_invoice: 'Active the Invoice',
  actived_invoice: ' The Invoice is Activated',
  preview_your_share: 'Preview  distribution ',
  Number_of_event: 'Number of event',
  time_of_creation: 'Creat at',
  Owner_details: 'Owner details',
  greetings: 'Greetings,',
  you_have_been_invited: 'You have been invited to join I.D 🎉',
  plz_wait_a_moment: 'Pleas wait a moment',
  thanks_time: 'Thanks time',
  averagePreparationTime: 'Average preparation time',
  minutes: 'minutes',
  seconds: 'seconds',
  select_menu: 'Select a menu',
  capacity_warning_message: 'The capacities are depleted in comparison to the total capacity.',
  add_product_alert: 'To add product to your tickets please link a store to your event',
  remaining_places: 'remaining places',
  navigate_to_event_menu: 'Navigate to event menu',
  you_have_no_store: 'You have no store',
  reject_order: 'Reject order',
  add_Waiter: 'Add Waiter',
  add_room: 'Add Room',
  room_name: 'Room Name',
  campaigns: {
    title: 'Mail Campaigns',
    segment: 'Segment',
    audience: 'Audience',
    createNew: 'Create New Campaign',
    name: 'Name',
    template: 'Template',
    scheduledTime: 'Scheduled Time',
    status: 'Status',
    actions: 'Actions',
    backToList: 'Back to Campaigns List',
    info: 'Campaign Info',
    mails: 'Mails',
    email: 'Email',
    emailStatus: 'Email Status',
    confirmDeletion: 'Confirm Deletion',
    deleteConfirmationMessage:
      'Are you sure you want to delete this mail campaign? This action cannot be undone.',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit Campaign',
    create: 'Create New Campaign',
    campaignName: 'Campaign Name',
    selectTemplate: 'Select a template',
    createNewTemplate: 'Create new template',
    save: 'Save',
    audienceType: {
      title: 'Audience',
      all: 'All Contacts',
      segment: 'Specific Segment',
      eventBuyers: 'Event Ticket Buyers',
    },
    emailstatus: {
      'email.sent': 'Sent',
      'email.delivered': 'Delivered',
      'email.delivery_delayed': 'Delivery Delayed',
      'email.complained': 'Complaint Received',
      'email.bounced': 'Bounced',
      'email.opened': 'Opened',
      'email.clicked': 'Clicked',
      'email.unsubscribed': 'Unsubscribed',
      'email.failed': 'Failed to Send',
      'email.blocked': 'Blocked',
      'email.dropped': 'Dropped',
      'email.deferred': 'Deferred',
      'email.rejected': 'Rejected',
    },
    drawer: {
      create: 'Create Campaign',
      edit: 'Edit Campaign',
      name: 'Campaign Name',
      audienceType: 'Audience Type',
      segment: 'Select Segment',
      draftInfo: 'Campaign will be saved as draft',
    },
    campaignStatus: {
      completed: 'Completed',
      pending: 'Pending',
      scheduled: 'Scheduled',
      sending: 'Sending',
      launched: 'Sent',
      failed: 'Failed',
      'template-ready': 'Template Ready',
    },
    stats: {
      title: 'Mail Statistics',
      delivered: 'Delivered',
      opened: 'Opened',
      clicked: 'Clicked',
      bounced: 'Bounced',
    },
    subject: 'Email Subject',
    subjectHelperText: 'You can customize the template subject for this campaign',
    launchType: {
      title: 'Launch Type',
      send: 'Send Now',
      immediate: 'Launch immediately',
      scheduled: 'Schedule for later',
    },
    schedule: {
      action: 'Schedule',
      title: 'Schedule Campaign',
      info: 'Schedule sending for campaign: {{name}}',
      scheduledTimeHelper: 'Choose a date and time in the future to send your campaign',
      errors: {
        scheduleTimeRequired: 'Please select a schedule time',
        testEmailRequired: 'Please enter a test email address',
        scheduleFailed: 'Failed to schedule campaign',
        testSendFailed: 'Failed to send test email',
      },
      success: {
        testSent: 'Test email sent successfully',
        launched: 'Campaign launched successfully',
        scheduled: 'Campaign scheduled successfully',
      },
    },
  },
  Breakdown_Price: 'Breakdown Price',
  Ticket_Price: 'Ticket Price',
  Platform_Fee: 'Platform Fee',
  Service_Fees: 'Service Fees',
  Per_Ticket: 'per ticket',
  Total: 'Total',
  Cost_to_buyers: 'Cost to buyers',
  contacts: {
    import: 'Import contacts',
    export: 'Export to CSV',
    deleteSelected: 'Delete selected',
    search: 'Search',
    noContactsToExport: 'No contacts to export.',
    errorDeletingContacts: 'Error deleting contacts',
    errorLoadingContacts: 'Error loading contacts',
    confirmDeletion: 'Confirm deletion',
    confirmDeletionMessage: 'Are you sure you want to delete the {count} selected contacts?',
    cancel: 'Cancel',
    delete: 'Delete',
    dragAndDropInstruction: 'Drag and drop a CSV or XLSX file here, or click to select',
    file: 'File: {name}',
    removeFile: 'Remove file',
    informationMapping: 'Information mapping',
    select: 'Select',
    additionalFields: 'Additional fields',
    errorParsingFile: 'Error parsing file. Please try again.',
    contactsImportedSuccessfully: 'Contacts imported successfully',
    errorImportingContacts: 'Error importing contacts. Please try again.',
    fields: {
      email: 'Email',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      age: 'Age',
      gender: 'Gender',
      country: 'Country',
      zone: 'Zone',
      postalCode: 'Postal Code',
    },
  },
  no_confirmed_tickets_to_export: 'No confirmed tickets to export',
  export_confirmed_ticket_ids_tooltip: 'Export confirmed ticket IDs',
  loading: 'Loading...',
  export_confirmed_tickets: 'Export Confirmed Tickets ({{count}})',
  check_invitation_list: 'Check invitation list',
  segments: {
    create: {
      engagement: 'Engagement',
      title: 'Create New Segment',
      selectType: 'Select a segment type',
      dynamicSegment: {
        title: 'Dynamic Filter Segment',
        description:
          'Apply a list of attributes to select a portion of your contacts. Your contacts will be automatically added or removed from this segment based on the chosen filters.',
      },
      manualSegment: {
        title: 'Manual Segment via CSV',
        description:
          'You can import a list of contacts from a CSV file to group them into a segment. You can use this feature to re-import existing contacts as a new segment.',
      },
      step: 'Step',
      of: 'of',
      removeFile: 'Remove file',
      newsletterContacts:
        '{{count}} / 2000 contacts subscribed to your newsletter already imported.',
      selectAgeRange: 'Select the age range you want to filter:',
      averageAge: 'Average: {{age}} years',
      infoKnownFor: 'This information is known for {{count}} contacts',
      selectCountries: 'Select one or more countries',
      selectZones: 'Select zones',
      addPostalCodes: 'Add postal codes (separated by comma)',
      selectLanguage: 'Select language',
      whenAdded: 'When this contact was added to your community',
      contactsImported: 'contacts subscribed to your newsletter already imported.',
      dropFileHere: 'Drop your CSV, XLS or XLSX file here',
      fileRequirements:
        'Your file must have at least one column with the email address of the contacts. And to send them newsletters, it must have a newsletter subscription column (yes/no).',
      removeFilters: 'Remove filters',
      contactInformation: 'CONTACT INFORMATION',
      marketing: 'MARKETING',
      history: 'HISTORY',
      fieldMapping: 'Field Mapping',
      additionalFields: 'Additional Fields',
      segmentName: 'Segment Name',
      description: 'Description',
      matchingContacts: 'matching contacts',
      back: 'Back',
      cancel: 'Cancel',
      next: 'Next',
      createSegment: 'Create Segment',
      importContacts: 'Import contacts as segment',
    },
    fieldsMapping: {
      name: 'Name',
      email: 'Email',
      firstName: 'First name',
      lastName: 'Last name',
      phone: 'Phone',
      age: 'Age',
      gender: 'Gender',
      country: 'Country',
      zone: 'Zone',
      postalCode: 'Postal code',
    },
    filters: {
      activeFilters: 'Active filters',
      hasEmail: 'Has an email',
      emailVerified: 'Email verified',
      hasPhone: 'Has a phone number',
      age: {
        rangeInfo: 'Age between {{min}} and {{max}} years',
        title: 'Age',
      },
      gender: 'Gender',
      genderSelection: 'Gender: {{genders}}',
      location: 'Location',
      language: 'Language',
      dateAdded: 'Date Added',
      selectCountries: 'Select one or more countries',
      selectZones: 'Select zones',
      postalCodes: 'Add postal codes (separated by commas)',
      selectLanguage: 'Select language',
      allTime: 'All time',
      today: 'Today',
      yesterday: 'Yesterday',
      last7days: 'Last 7 days',
      last14days: 'Last 14 days',
      last30days: 'Last 30 days',
      last90days: 'Last 90 days',
      customDates: 'Custom dates',
      from: 'From',
      to: 'To',
      events: {
        title: 'Events & Tickets',
        hasBoughtTicket: 'Has bought tickets',
        hasAttendedEvents: 'Has attended events',
        minEvents: 'Minimum events attended',
        ticketInfo: 'Has bought at least one ticket',
        attendanceInfo: 'Has attended at least {{count}} events',
        attendanceRange: 'Events attended',
        selectRange: 'Select the minimum number of events attended',
      },
    },
  },
  // stripe_connect moved to modules/stripeConnect.en.ts
  segment: {
    Create: {
      matchingContacts: 'matching contacts',
      back: 'Back',
      cancel: 'Cancel',
      next: 'Next',
      importContacts: 'Import contacts',
      title: 'Create segment',
    },
  },

  survey: {
    title: 'Event Survey Creator',
    enable: 'Enable Survey',
    noResponses: 'No responses yet',
    totalResponses: 'Total Responses: {{count}}',
    noSurveyData: 'No survey data available',
    errorLoading: 'Error loading survey data',
    question: {
      title: 'Question {{number}}',
      required: 'Required',
      text: 'Question Text',
      type: 'Question Type',
      types: {
        shortText: 'Short Text',
        longText: 'Long Text',
        radio: 'Radio Buttons',
        checkbox: 'Checkboxes',
      },
      options: 'Options:',
      addOption: 'Add Option',
      submit: 'Submit Question',
      validation: {
        emptyText: 'Question text cannot be empty.',
        radioOptions: 'Radio question must have at least one option.',
        checkboxOptions: 'Checkbox question must have at least one option.',
      },
    },
    addQuestion: 'Add Question',
    answersSummary: 'Answers Summary',
  },
  guests: {
    guestLists: 'Guest Lists',
    addList: 'Add List',
    addGuest: 'Add Guest',
    searchGuests: 'Search guests',
    addNewList: 'Add New List',
    listName: 'List Name',
    guestList: 'Guest List',
    sendEmailsToNewGuests: 'Send emails to new guests',
    single: 'Single',
    import: 'Import',
    text: 'Text',
    name: 'Name',
    email: 'Email',
    totalTickets: 'Total Tickets',
    freeTickets: 'Free Tickets',
    dragDropCsv: 'Drag and drop a CSV file here, or click to select a file',
    guestDetailsPlaceholder:
      'Enter guest details (one per line): Name, TotalTickets+FreeTickets, Email',
    importGuests: 'Import Guests',
    editGuest: 'Edit Guest',
    update: 'Update',
    delete: 'Delete',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage:
      'Are you sure you want to delete this guest? This action cannot be undone.',
    cancel: 'Cancel',
    mapColumns: 'Map Columns',
    emailLabel: 'Email',
    ticketsInfo: 'Tickets',
    deleteList: 'Delete Guest List',
    deleteListConfirmation: 'Are you sure you want to delete the guest list: ',
    deleteListWarning: 'This will also delete all guests in this list and cannot be undone.',
    invalidFileType: 'Invalid file type. Please upload a CSV or Excel file (.csv, .xlsx, .xls)',
    csvImportInstructions:
      'Upload a CSV or Excel file with guest information. The file must contain the following columns:',
    csvRequiredColumns: 'Required Columns',
    nameColumnDescription: "Guest's full name (required)",
    emailColumnDescription: "Guest's email address (optional)",
    totalTicketsColumnDescription: 'Total number of tickets allocated (minimum 1)',
    freeTicketsColumnDescription:
      'Number of complimentary tickets (must be less than or equal to total tickets)',
  },
  promoboosters: {
    referral_sales: 'Referral Sales',
    other_sales: 'Other Sales',
    available: 'Available',
    No_tickets_sold_yet: 'No tickets sold yet',
    ticket_category: 'Ticket Category',
    total_sold: 'Total Sold',
    initial_quantity: 'Initial Quantity',
  },
  templates: {
    createNew: 'Create New Template',
    name: 'Template Name',
    subject: 'Email Subject',
    nameAndSubjectRequired: 'Template name and subject are required',
    createSuccess: 'Template created successfully',
    createError: 'Failed to create template',
  },
  confirm_refund: 'Confirm Refund',
  refund_confirmation_message:
    'Are you sure you want to refund this ticket? This action cannot be undone.',
  refund_amount: 'Refund Amount',
  processing: 'Processing...',
  deduct_platform_fee: 'Deduct Platform Fee',
  platform_fee_toggle_description:
    'When enabled, the platform fee will be deducted from the refund amount',
  original_price: 'Original Price',
  platform_fee: 'Platform Fee',
  platform_fee_deduction: 'Platform Fee Deduction',
  final_refund_amount: 'Final Refund Amount',
  'Price Deformations': 'Price Deformations',
  'Active Price Deformations': 'Active Price Deformations',
  'Add Deformation': 'Add Deformation',
  'Remove Deformation': 'Remove Deformation',
  'Deformed Price': 'Deformed Price',
  'Final Price': 'Final Price',
  'No deformations available': 'No price deformations available',
  'Price deformation added': 'Price deformation added successfully',
  'Price deformation removed': 'Price deformation removed',
  'Price Deformations Management': 'Price Deformations Management',
  'Add Price Deformation': 'Add Price Deformation',
  'No price deformations defined yet': 'No price deformations defined yet',
  Inactive: 'Inactive',
  off: 'off',
  Priority: 'Priority',
  Domains: 'Domains',
  'Are you sure you want to delete this price deformation?':
    'Are you sure you want to delete this price deformation?',
  'Price deformation deleted successfully': 'Price deformation deleted successfully',
  'Failed to delete price deformation': 'Failed to delete price deformation',
  'Ticket Restrictions': 'Ticket Restrictions',
  'Add Access Restriction': 'Add Access Restriction',
  'Access Restriction': 'Access Restriction',
  'Allowed Domains': 'Allowed Domains',
  'Restriction Rules': 'Restriction Rules',
  'A ticket can have either multiple price deformations OR one access restriction, but not both.':
    'A ticket can have either multiple price deformations OR one access restriction, but not both.',
  'Adding an access restriction will remove all price deformations. Continue?':
    'Adding an access restriction will remove all price deformations. Continue?',
  Access_Restriction_Description: 'Access to tickets can be limited to specific email domains.',
  total_tickets_sold: 'Total tickets sold',
  total_revenue: 'Total revenue',
  eventTicketStatistics: 'Event Ticket Statistics',
  eventCapacity: 'Event Capacity',
  totalTickets: 'Total Tickets',
  totalReservations: 'Total Reservations',
  ticketName: 'Ticket Name',
  initialQuantity: 'Initial Quantity',
  soldQuantity: 'Sold Quantity',
  noTicketData: 'No ticket data available',
  errorLoadingTickets: 'Error loading ticket data',
  na: 'N/A',
  confirm_send_email: 'Confirm Email Send',
  send_email_confirmation_message:
    'Are you sure you want to send the confirmation email to this recipient?',
  recipient: 'Recipient',
  sending: 'Sending...',
  send: 'Send',
  ticketInvitation: {
    import: {
      csvMode: 'Import CSV',
      singleMode: 'Import Individual',
      title: 'Import Invitations',
      select_ticket_category: 'Select Ticket Category',
      progress: 'Processing {{current}}/{{total}} ({{success}} successful, {{failed}} failed)',
      dragOrSelect: 'Drop your CSV file here or click to select',
      dropHere: 'Drop the CSV file here',
      mapColumns: 'Map CSV Columns',
      previewTitle: 'Preview',
      invitationMode: 'Invitation',
      physicalMode: 'Physical Ticket',
      records: 'records',
      firstThreeRecords: 'First three records',
      importButton: 'Import {{count}} invitations',
      errors: {
        unknown: 'Unknown error occurred',
        csvEmpty: 'The CSV file is empty',
        invalidFormat: 'Invalid CSV format',
        parseError: 'Error parsing CSV file',
        fileTooLarge: 'File is too large (max 5MB)',
        invalidFileType: 'Only CSV files are allowed',
        invalidDataRows: '{{count}} rows contain invalid data',
        missingMapping: 'Please map all required columns',
        creationFailed: 'Failed to create invitations',
      },
      success: {
        partial:
          'Import completed: {{success}} successful, {{failed}} failed.\nDetails:\n{{details}}',
        complete: 'Successfully created {{count}} invitations',
        noErrors: 'No errors found',
        single: 'Successfully created invitation',
        physical: 'Successfully created physical ticket',
      },
      steps: {
        setup: 'Setup',
        preview: 'Preview & Import',
      },
      next: 'Next',
      back: 'Back',
      summary: 'Import Summary',
      totalRecords: 'Total Records',
      selectedTicket: 'Selected Ticket Category',
      explanation: {
        main: 'Import tickets for multiple attendees using a CSV file. Perfect for migrating from other ticketing systems or creating tickets for a pre-defined guest list.',
        features: 'This import tool will:',
        feature1: 'Create digital tickets with unique QR codes for each attendee',
        feature2: 'Send confirmation emails to attendees with their ticket QR codes',
        feature3: 'Allow you to assign specific ticket categories to all imported guests',
      },
    },
  },
  tickets: {
    price_per_ticket_ht: 'per ticket HT',
    hide_description: 'Hide ticket (only visible on secret page)',
    validation: {
      titleRequired: 'Title is required',
      descriptionRequired: 'Description is required',
      priceZero: 'Price cannot be zero',
      priceRequired: 'Price is required',
      initialQuantityZero: 'Initial quantity cannot be zero',
      maxQuantityLimit: 'Max quantity must be smaller than initial quantity',
      maxQuantityZero: 'Max quantity cannot be zero',
      minQuantityLimit: 'Min quantity must be smaller than max quantity and initial quantity',
      minQuantityZero: 'Min quantity cannot be zero',
      categoryRequired: 'Category is required',
      productRequired: 'Product is required',
      quantityRequired: 'Quantity is required',
      quantityGreaterThanZero: 'Quantity must be greater than zero',
      withProductRequired: 'With product is required when iscomposite is true',
      fieldRequired: 'This field is required',
      vatRateRange: 'VAT rate must be between 1 and 100',
    },
  },
  accessRequests: {
    sign_in: 'Sign in',
    already_have_account: 'Already have an account?',
    form_description: 'Fill out the form below to request access to our platform',
    welcome_message: 'Get access to our platform',
    request_access: 'Request Access',
    request_access_title: 'Request Admin Access',
    full_name: 'Full Name',
    email: 'Email',
    company_name: 'Company Name',
    position: 'Position',
    reason: 'Why do you need access?',
    reason_optional: 'Optional',
    cancel: 'Cancel',
    submit: 'Submit Request',
    submitting: 'Submitting...',
    please_fill_all_fields: 'Please fill in all required fields',
    invalid_email: 'Please enter a valid email address',
    error_submitting_request: 'Error submitting request. Please try again.',
    phone: 'Phone Number',
    phone_optional: 'Optional - Include country code',
    company_optional: 'Optional',
    position_optional: 'Optional',
    source: 'How did you find us?',
    invalid_phone: 'Please enter a valid phone number',
    source_options: {
      search_engine: 'Search Engine (Google, Bing, etc.)',
      social_media: 'Social Media',
      friend: 'Friend or Colleague',
      advertisement: 'Advertisement',
    },
  },
  price_deformation: {
    name_required: 'Name is required',
    deformation_type_required: 'Deformation type is required',
    value_required: 'Value is required',
    value_positive: 'Value must be positive',
    invalid_value: 'Invalid value',
    domain_required: 'At least one domain is required',
    edit_price: 'Edit Price Deformation',
    new_price: 'New Price Deformation',
    edit_access: 'Edit Access Restriction',
    new_access: 'New Access Restriction',
    name: 'Name',
    description: 'Description',
    active: 'Active',
    deformation_type: 'Deformation Type',
    percentage: 'Percentage',
    fixed_amount: 'Fixed Amount',
    deformation_value: 'Deformation Value',
    email_domains: 'Email Domains',
    add_domain: 'Add Domain',
    priority: 'Priority',
    cancel: 'Cancel',
    update: 'Update',
    create: 'Create',
    priority_info:
      'Priority determines the order in which restrictions are applied. Higher priority (larger number) restrictions are checked first. For example, a restriction with priority 2 will be checked before priority 1.',
    other: 'Other',
    condition_type: 'Restriction Type',
    email_domain_type: 'Email Domain',
    email_address_type: 'Email Address',
    email_addresses: 'Email Addresses',
    add_email: 'Add Email',
    import_csv: 'Import from CSV',
    email_required: 'At least one email address is required',
    emails_count: '{{count}} email addresses added',
    max_tickets_per_email: 'Maximum Tickets Per Email',
    max_tickets_placeholder: 'Leave empty for unlimited',
    max_tickets_helper: 'Limit how many tickets a customer can purchase with the same email',
    max_tickets_info:
      'Set to limit the number of tickets that can be purchased with a single email address. Leave empty for no limit.',
    min_tickets_value: 'Minimum value is 1',
    integer_tickets_value: 'Please enter a whole number',
    large_email_list_info:
      'If you have a large list of email addresses, consider using a CSV file for easier import.',
    showing_preview: 'Showing preview for {{count}} email addresses',
  },
  single_ticket: 'Ticket',
  Edit_Messages: 'Edit Messages',
  Email_Preview: 'Email Preview',
  Language: 'Language',
  Error_loading_email_template: 'Error loading email template',
  No_email_template_found: 'No email template found',
  No_preview_available: 'No preview available',
  Edit_success: 'Edit success!',
  Edit_failed: 'Edit failed!',
  Loading: 'Loading...',
  multiple_tickets: 'Tickets',
  access_restrictions: 'Access Restrictions',
  hidden_links: 'Hidden Links',
  tickets_count: 'Tickets count',
  stop_sell_time: 'Stop sell time is at',
  drag_drop_instruction: 'Drag and drop to reorder tickets',
  create_tickets: 'Create tickets for your event',
  access_restriction_title: 'Access Restriction',
  access_restriction_description: 'Manage who can access your tickets',
  add_access_restriction: 'Add Access Restriction',
  inactive: 'Inactive',
  priority: 'Priority',
  allowed_domains: 'Allowed Domains',
  delete_confirmation: 'Are you sure you want to delete this access restriction?',
  'Domain-based': 'Domain-based',
  'Email-based': 'Email-based',
  'Allowed Values': 'Allowed Values',
  'email addresses': 'email addresses',
  'Access restrictions limit ticket purchases to specific email domains or addresses. Multiple restrictions can be active at the same time.':
    'Access restrictions limit ticket purchases to specific email domains or addresses. Multiple restrictions can be active at the same time.',
  'Access restrictions limit ticket purchases to specific email domains or addresses. Only one restriction can be active at a time.':
    'Access restrictions limit ticket purchases to specific email domains or addresses. Only one restriction can be active at a time.',
  'Allowed Emails': 'Allowed Emails',
  more: 'more',
  'No access restrictions have been created yet. Create one to limit ticket purchases to specific email domains or addresses.':
    'No access restrictions have been created yet. Create one to limit ticket purchases to specific email domains or addresses.',
  'Are you sure you want to delete this access restriction?':
    'Are you sure you want to delete this access restriction?',
  'Successfully added': 'Successfully added',
  'Successfully updated': 'Successfully updated',
  bus: {
    title: 'Bus Rides Management',
    newTrip: 'New Bus Trip',
    active: 'Active',
    past: 'Past',
    all: 'All',
    name: 'Bus name',
    description: 'Description',
    route: 'Route',
    departureLocation: 'Departure Location',
    arrivalLocation: 'Arrival Location',
    duration: 'Duration',
    minutes: 'minutes',
    capacity: 'Capacity',
    price: 'Price',
    currency: 'Currency',
    isRoundTrip: 'Round Trip',
    schedules: 'Schedules',
    noTripsFound: 'No bus trips found',
    noSchedulesFound: 'No schedules found for this trip',
    actions: 'Actions',
    addSchedule: 'Add Schedule',
    edit: 'Edit Trip',
    delete: 'Delete Trip',
    confirmDelete: 'Are you sure you want to delete this bus trip?',
    confirmDeleteSchedule: 'Are you sure you want to delete this schedule?',
    departureDate: 'Departure Date',
    departureTime: 'Departure Time',
    returnDate: 'Return Date',
    returnTime: 'Return Time',
    availableSeats: 'Available Seats',
    status: 'Status',
    createSuccess: 'Bus trip created successfully',
    createError: 'Error creating bus trip',
    updateSuccess: 'Bus trip updated successfully',
    updateError: 'Error updating bus trip',
    deleteSuccess: 'Bus trip deleted successfully',
    deleteError: 'Error deleting bus trip',
    scheduleAddSuccess: 'Schedule added successfully',
    scheduleAddError: 'Error adding schedule',
    scheduleDeleteSuccess: 'Schedule deleted successfully',
    scheduleDeleteError: 'Error deleting schedule',
    fetchError: 'Error fetching bus trips',
    import: 'Import Trips',
    importing: 'Importing bus trips',
    importSuccess: 'Bus trips imported successfully',
    importError: 'Failed to import bus trips',
    parseError: 'Failed to parse JSON file',
    readError: 'Failed to read file',
    invalidFileType: 'Invalid file type. Please select a JSON file',
    importBusTrips: 'Import Bus Trips',
    previewImport: 'Preview Import',
    foundTrips: 'Found {count} trips in file',
    details: 'Details',
    roundTrip: 'Round Trip',
    showSchedules: 'Show schedules',
    hideSchedules: 'Hide schedules',
    importToDatabase: 'Import to Database',
    dropzoneInstructions: 'Upload a JSON file with bus trips data',
    dragAndDrop: 'Drag and drop your file here',
    dropFileHere: 'Drop the file here',
    orClickToSelect: 'or click to select file',
    onlyJsonFiles: 'Only JSON files are supported',
    direction: 'Direction',
    tripNumber: 'Trip #',
    filterByDirection: 'Filter by direction',
    allDirections: 'All directions',
    outbound: 'Outbound',
    return: 'Return',
    aller: 'Outbound',
    retour: 'Return',
    allSchedules: 'All schedules',
    outboundSchedules: 'Outbound schedules',
    returnSchedules: 'Return schedules',
    outboundTripNote:
      'This outbound trip will go from {from} to {to} with a duration of {duration} minutes.',
    returnTripNote:
      'This return trip will go from {from} to {to} with a duration of {duration} minutes.',
    passengerCount: 'Passengers',
    bookingSummary: 'Booking Summary',
    overallFillRate: 'Overall Fill Rate',
    totalPassengers: 'Total Passengers',
    trips: 'trips',
    passengers: 'passengers',
    bookingLegend: 'Booking Status Legend',
    plentySeats: 'Plenty of seats available',
    fillingUp: 'Filling up',
    almostFull: 'Almost full',
    scheduleManager: 'Schedule Manager',
    selectBus: 'Select Bus',
    seats: 'seats',
    viewSchedules: 'View Schedules',
    editSchedule: 'Edit Schedule',
    statusActive: 'Active',
    statusAvailable: 'Available',
    statusFull: 'Full',
    statusCancelled: 'Cancelled',
    scheduleUpdateSuccess: 'Schedule updated successfully',
    scheduleUpdateError: 'Error updating schedule',
    customMessage: 'Client Message',
    customMessagePlaceholder:
      'You can book bus tickets in either direction. Return tickets are free when you purchase a departure ticket.',
    customMessageHelp:
      'This message will be displayed to clients when selecting buses for this trip.',
    totalRevenue: 'Total Revenue',
    occupancyRate: 'Occupancy Rate',
    busStats: 'Bus Statistics',
    activeBuses: 'Active Buses',
    totalSales: 'Total Sales',
    fillRate: 'Fill Rate',
    totalCapacity: 'Total Capacity',
    allBuses: 'All Buses',
    observation: 'Observation',
    seatsLeft: 'seats left',
  },
  // Role translations
  roles: {
    Owner: 'Owner',
    organizer: 'Organizer',
    promoter: 'Promoter',
    ambassador: 'Ambassador',
    bouncer: 'Bouncer',
    staff: 'Staff',
    Ambassador: 'Ambassador',
    Bouncer: 'Bouncer',
    Staff: 'Staff',
    Organizer: 'Organizer',
    Referral: 'PromoBooster',
  },
  join_instadrink: 'Join ID Network',
  join_instadrink_network: 'Join the ID Network',
  become_part_of_our_community: 'Become part of our community',
  i_would_like_to_invite_you_to_join_my_network: 'I would like to invite you to join my network!',
  loading_public_invite: 'Loading invitation link...',
  join_network_now: 'Join Network',
  i_am_a: 'Role',
  processing_invitation_request: 'Processing invitation request...',
  please_fix_form_errors: 'Please fix the form errors',
  thank_you_for_joining_my_network: 'Thank you for joining my network 🥂',
  invitation_request_sent_successfully_check_your_email_finish_registration:
    'Invitation request sent successfully. Please check your email 📧 to finish registration.',
  // Invitation translations
  invitation: {
    you_are_invited_as: 'You are invited as',
    invitation_date: 'Invitation date',
    invitation_details: 'Invitation details',
    invitation_preview: 'Invitation preview',
    please_fix_form_errors: 'Please fix the form errors',
    error_loading_invitation: 'Error loading invitation',
    status: {
      pending: 'Pending',
      accepted: 'Accepted',
      canceled: 'Canceled',
      rejected: 'Rejected',
      expired: 'Expired',
    },
    you_can_now_login: 'You can now login',
    redirecting_to_dashboard: 'Redirecting to dashboard...',
    logging_in_automatically: 'Logging in automatically...',
    go_to_login: 'Go to login page',
    account_created_successfully: 'Account created successfully',
    by: 'by',
    password_requirements: {
      min: 'At least 8 characters',
      uppercase: 'At least one uppercase letter',
      lowercase: 'At least one lowercase letter',
      number: 'At least one number',
      special: 'At least one special character',
    },
  },
  reservation_details: 'Reservation Details',
  reservation_id: 'Reservation ID',
  client: 'Client',
  email: 'Email',
  phone: 'Phone',
  payment_information: 'Payment Information',
  total_tickets: 'Total Tickets',
  notes: 'Notes',
  // General drawer titles and labels
  edit_reservation: 'Edit Reservation',
  edit_ticket: 'Edit Ticket',
  edit_client_information: 'Edit Client Information',
  edit_ticket_info: 'Edit Ticket Information',
  edit_reservation_info: 'Edit Reservation Information',

  // Tabs
  edit_form: 'Edit Form',

  // Ticket selection
  select_ticket_to_edit: 'Select a ticket to edit',

  // Form labels
  client_information: 'Client Information',
  ticket_holder_information: 'Ticket Holder Information',
  note_client_email_unchanged: "Note: Client's email remains unchanged",

  // Messages
  update_failed: 'Update failed',
  save_changes: 'Save Changes',
  saving: 'Saving...',
  ticket_updated_successfully: 'Ticket information updated successfully',
  error_updating_ticket: 'Error updating ticket information',
  invalid_email_format: 'Invalid email format',
  ticket: {
    insurance_options: 'Garantee Options',
    default_insurance_description:
      'This ticket includes a refund Garantee. You can request a refund up to the specified time before the event starts.',
    enable_insurance: 'Enable refund Garantee option for customers',
    insurance_price: 'GaranteePrice',
    max_refund_time: 'Maximum Refund Time',
    refund_time_before_event: 'Hours before event start when refund is available',
    insurance_description: 'Garantee Description',
    insurance_description_placeholder: 'Explain the Garantee terms to your customers',
    insurance_description_help:
      'Define the Garantee settings for this ticket. Customers will be able to purchase this Garanteeduring checkout.',
    insurance_options_readonly: 'Garantee Options (Read Only)',
  },
  ticketView: {
    insurance: 'Insurance',
    insurance_available: 'Refund Garantee available',
    insurance_price: 'Garantee Price',
    insurance_refund_time: 'Refund Time Limit',
    hours_before_event: 'hours before event',
    insurance_description: 'Garantee Terms',
  },
  event_faqs: {
    title: 'Event FAQs',
    tabs: {
      sections: 'FAQ Sections',
      useful_links: 'Useful Links',
      contacts: 'Contact Information',
    },
    add_section: 'Add Section',
    edit_section: 'Edit Section',
    section_title: 'Section Title',
    no_sections: "No FAQ sections created yet. Click 'Add Section' to create your first section.",
    items_count: '{{count}} questions',
    add_item: 'Add Question',
    edit_item: 'Edit Question',
    question: 'Question',
    answer: 'Answer',
    no_items: 'No questions in this section yet',
    confirm_delete_section:
      'Are you sure you want to delete this section? All questions in this section will be deleted.',
    confirm_delete_item: 'Are you sure you want to delete this question?',

    add_link: 'Add Link',
    edit_link: 'Edit Link',
    link_title: 'Link Title',
    link_url: 'URL',
    no_links: "No useful links created yet. Click 'Add Link' to create your first link.",
    confirm_delete_link: 'Are you sure you want to delete this link?',
    invalid_url: 'Please enter a valid URL (e.g., https://example.com)',

    add_contact: 'Add Contact',
    edit_contact: 'Edit Contact',
    contact_name: 'Name',
    contact_role: 'Role',
    contact_email: 'Email',
    contact_phone: 'Phone',
    no_contacts: "No contacts created yet. Click 'Add Contact' to create your first contact.",
    confirm_delete_contact: 'Are you sure you want to delete this contact?',
    invalid_email: 'Please enter a valid email address',
  },
  common: {
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    actions: 'Actions',
    save_success: 'Changes saved successfully',
    save_error: 'Error saving changes',
    error_loading: 'Error loading data',
    copy: 'Copy',
    copied: 'Copied',
    none: 'None',
  },
  ticketsStats: {
    timeAnalysis: 'Time Analysis',
    dailySalesVelocity: 'Daily Sales Velocity',
    hourlySalesVelocity: 'Hourly Sales Velocity',
    peakDays: 'Peak Sales Days',
    peakHours: 'Peak Sales Hours',
    ticketsSold: 'Tickets Sold',
    salesCount: 'Sales Count',
    revenue: 'Revenue',
    noTimeData: 'No time data available',
    noHourlyDataForSelectedDay: 'No hourly data available for the selected day',
    noTicketData: 'No ticket data available for analysis',
    day: 'Day',
    hour: 'Hour',
    selectDay: 'Select Day',
    peakPeriods: 'Peak Periods',
  },

  artistLineup: {
    title: 'Artist Lineup',
    manageLineup: 'Manage Artist Lineup',
    currentLineup: 'Current Lineup',
    noArtists: 'No artists have been added to this event yet.',
    addFirstArtist: 'Add Your First Artist',
    addArtist: 'Add Artist',
    editArtist: 'Edit Artist',
    removeSuccess: 'Artist removed successfully',
    addSuccess: 'Artist added successfully',
    updateSuccess: 'Artist updated successfully',
    reorderSuccess: 'Lineup reordered successfully',
    confirmRemove: 'Are you sure you want to remove this artist?',
    artistName: 'Artist Name',
    performanceTime: 'Performance Time',
    biography: 'Biography',
    imageUrl: 'Artist Image URL',
    socialLinks: 'Social Media Links',
    website: 'Website',
    followers: 'followers',
    viewOnSpotify: 'View on Spotify',
    generateLink: 'Share with Music Platforms',
    shareMusicPlatform: 'Share with Music Platforms',
    shareInfo:
      'Share these links with music platforms to help promote your event. The booking link is for users to purchase tickets, while the API link provides event data for platforms to integrate with.',
    bookingLinkTitle: 'Booking Link (For Users)',
    apiLinkTitle: 'API Link (For Music Platforms)',
    securityNote: 'Security Note',
    securityDetails:
      'These links include a security token unique to your event. You can regenerate the link at any time if needed.',
    linkCopied: 'Link copied to clipboard',
    searchArtist: 'Search Artist on Spotify',
    searchSpotify: 'Search for an artist on Spotify',
    addArtistDetails: 'Add Artist Details',
    manualEntry: "Can't find your artist? Add manually:",
    addManually: 'Add Artist Manually',
    artistFound: 'Artist found on Spotify! Fill in any additional details below.',
    noResults: 'No artists found with that name',
    performsAt: 'Performs at',
    notifySubscribers: 'Notify Artist Followers',
    notifySuccess: 'Notification sent successfully',
    confirmNotify:
      'This will notify subscribers of Spotify artists in your lineup about your event. Continue?',
  },
  passculture: {
    // General
    subtitle: 'Pass Culture Integration',
    selectVenue: 'Select Pass Culture Venue',
    saveVanue: 'Save Venue',
    venueSaved: 'Venue saved successfully',
    venueSelectionHelp:
      'Select a venue from your Pass Culture account to link it to this event. This is required before publishing to Pass Culture.',
    selectVenueDescription:
      'Before publishing to Pass Culture, you need to select a venue from your Pass Culture account.',
    venue: 'Venue',
    venueSelected: 'Pass Culture Venue Selected',
    venueLinkedSuccess:
      'Your event is now linked to a Pass Culture venue. You can now configure the event description for Pass Culture.',
    ticketCategories: 'Ticket Categories',
    // Description section
    eventDescription: 'Pass Culture Description',
    eventDescriptionHelp:
      'Provide a detailed description of your event for Pass Culture users. This can be different from your main event description.',
    description: 'Description',

    // Publishing
    readyToPublish: 'Ready to Publish',
    publishInfo:
      'Your event is now ready to be published to Pass Culture. Click the button below to publish.',
    publish: 'Publish to Pass Culture',
    refreshStatus: 'Refresh Status',
    publishing: 'Publishing...',

    // Publication data
    publicationData: 'Pass Culture Publication Data',
    publishedOn: 'Published On',
    passCultureId: 'Pass Culture ID',
    status: 'Status',
    details: 'Pass Culture Event Details',

    comingSoon: {
      title: 'Pass Culture Integration',
      message:
        'Pass Culture integration is coming soon. This feature will allow you to publish your events to the Pass Culture platform. Stay tuned for updates!',
    },
    addStocks: 'Add Stocks',
    stocksInformation: 'Stocks Information',
    stocksAddedSuccess: '{{count}} stocks have been successfully added to Pass Culture',
    stocksCount: 'Total Stocks',
    lastStockUpdate: 'Last Update',
    warnings: {
      noStocks: 'No stocks have been added to this event on Pass Culture yet',
      noTicketsFound:
        'No tickets found for this event. Please create tickets before adding stocks.',
      noOrganizerLinked:
        'This event is not linked to an organizer. Please assign an organizer to the event first.',
    },
    stocks: {
      dialogTitle: 'Add Stocks to Pass Culture',
      step1: 'Configure Stocks',
      step1Description: 'Choose how you want to add stocks to Pass Culture for this event.',
      step2: 'Confirm and Create',
      step2Description: 'Review your selection and create the stocks on Pass Culture.',
      step3: 'Success',
      step3Description: 'Your stocks have been successfully created on Pass Culture.',
      useExistingTickets: 'Use existing tickets from my event',
      ticketsFound: 'Tickets found',
      ticketsDescription:
        'Your event tickets will be mapped to Pass Culture price categories automatically.',
      willUseExistingTickets: 'You will create {{count}} stocks based on your existing tickets',
      willCreateCustomStocks: 'You will create custom stocks on Pass Culture',
      createStocks: 'Create Stocks',
      successMessage: 'Stocks have been successfully created on Pass Culture',
    },

    // Success messages
    success: {
      venueSaved: 'Venue successfully linked to event',
      descriptionSaved: 'Pass Culture description saved successfully',
      eventPublished: "Event '{name}' successfully published to Pass Culture",
      statusRefreshed: 'Pass Culture status successfully refreshed',
      emailSaved: 'Contact email saved successfully',
      stocksAdded: 'Stocks were successfully added to Pass Culture',
    },

    // Error messages
    errors: {
      noVenueSelected: 'You must select a venue before publishing to Pass Culture',
      saveFailed: 'Failed to save changes',
      loadingVenuesFailed: 'Failed to load venues from Pass Culture',
      publishEventFailed: 'Failed to publish event to Pass Culture',
      refreshStatusFailed: 'Failed to refresh Pass Culture status',
      eventNotFound: 'Event not found',
      invalidEmail: 'Please enter a valid email address',
      noContactEmail: 'Please provide a contact email before publishing',
      addStocksFailed: 'Failed to add stocks to Pass Culture',
    },

    // Dialog content
    publishDialog: {
      title: 'Publish to Pass Culture',
      publishing: 'Publishing to Pass Culture...',
      description:
        'You are about to publish this event to Pass Culture. Once published, it will be available to Pass Culture users after approval.',
    },

    // Event status

    eventDetails: 'Event Details',
    category: 'Category',
    date: 'Date',
    time: 'Time',
    venueId: 'Venue ID',
    passCultureInfo: 'Pass Culture Information',
    passCultureIntegration: 'Pass Culture Integration',
    notPublishedYet: 'This event has not been published to Pass Culture yet.',
    currentStatus: 'Current Status',
    passCultureDetails: 'Pass Culture Details',
    lastUpdated: 'Last Updated',
    bookingsCount: 'Bookings',
    remainingStock: 'Remaining Stock',
    publicationDate: 'Publication Date',
    lastModified: 'Last Modified',
    rejectionReason: 'Rejection Reason',
    rawResponse: 'Raw Data from Pass Culture',
    unknown: 'Unknown',
    noStatusData: 'No status data is available. Check the status to get updated information.',
    checkStatus: 'Check Status',
    ticketsMapping: 'Tickets Mapping',
    ticketsMappingDescription:
      'This table shows how your event tickets are mapped to Pass Culture categories.',
    price: 'Price',
    available: 'Available',
    passCultureCategory: 'Pass Culture Category',
    notMapped: 'Not Mapped',
    ticketsMappingNote:
      'Only tickets that are available for sale will be mapped to Pass Culture categories.',
    noTicketsAvailable: 'No tickets are available for this event.',
    ticketInfo: 'Ticket Information',
    moreCategories: 'And more categories...',

    tabs: {
      overview: 'Overview',
      status: 'Status',
      tickets: 'Tickets',
    },

    events: {
      notPublished: 'Not Published',
      publishError: 'Publish Error',
      published: 'Published',
    },

    contactEmail: 'Contact Email',
    contactEmailHelp:
      'Please provide a contact email for Pass Culture users to reach you. This email will be shown to users on the Pass Culture platform.',
  },
  passculturedocumentation: {
    title: 'Pass Culture Integration',
    category: 'Event Setup',
    intro:
      'Pass Culture is a French government initiative that provides cultural vouchers to young people. By integrating with Pass Culture, you can make your events accessible to Pass Culture users and expand your audience reach. This guide will walk you through the complete setup process for integrating individual events with Pass Culture.',
    important: 'Important:',
    eventLevelConfig:
      'Pass Culture integration is configured at the event level. Each event that you want to make available on Pass Culture needs to be individually configured through its own Pass Culture tab.',

    whatIs: {
      title: 'What is Pass Culture?',
      description:
        'Pass Culture is a digital platform that offers cultural credits to young people aged 15-20 in France. Users receive vouchers that can be used to purchase cultural products and services, including:',
      services: {
        concerts: 'Concerts and music events',
        theater: 'Theater and cinema tickets',
        books: 'Books and cultural workshops',
        exhibitions: 'Art exhibitions and cultural experiences',
      },
    },

    benefits: {
      title: 'Benefits of Integration',
      youngAudience: 'Reach young audiences (15-20 years)',
      governmentBacked: 'Government-backed payment system',
      visibility: 'Increased event visibility',
      guaranteedPayments: 'Guaranteed payments',
    },

    prerequisites: {
      title: 'Prerequisites',
      description:
        'Before you can integrate with Pass Culture, you need to meet certain requirements and have specific information ready.',
      business: {
        title: 'Required Business Information',
        siren: 'SIREN or SIRET number',
        sirenDesc: 'Your official French business registration number',
        legalEntity: 'Legal business entity',
        legalEntityDesc: 'Must be a registered business in France',
        license: 'Cultural activity license',
        licenseDesc: 'Appropriate licensing for cultural event organization',
      },
      account: {
        title: 'Pass Culture Account Setup',
        register: 'Register on Pass Culture Pro',
        registerDesc: 'Create an account at https://passculture.pro',
        verification: 'Complete business verification',
        verificationDesc: 'Submit required documents for approval',
        apiAccess: 'API access approval',
        apiAccessDesc: 'Wait for Pass Culture team approval for API access',
      },
    },

    integration: {
      title: 'Integration Setup Guide',
      description:
        'Follow these steps to integrate Pass Culture with your Instadrink organization. Make sure you have completed the prerequisites before starting.',
    },

    steps: {
      businessId: {
        title: 'Add Your Business Identifier',
        description:
          'First, you need to add your SIREN or SIRET number to your organization profile in Instadrink.',
        step1: 'Go to Organization Settings → General Information',
        step2: 'Enter your SIREN (9 digits) or SIRET (14 digits) number',
        step3: 'Save your organization settings',
        warning:
          'Your SIREN/SIRET number must match exactly with the one registered in your Pass Culture Pro account.',
      },
      access: {
        title: 'Access Pass Culture Integration',
        description: 'Navigate to the Pass Culture integration section for your specific event.',
        step1: 'Go to your Event Dashboard',
        step2: "Click on the 'Pass Culture' tab in the event settings",
        step3: "You'll see your organization's SIREN/SIRET number displayed",
        step4: "The integration will show as 'Integration' environment by default",
      },
      venue: {
        title: 'Select Event Venue',
        description:
          "Once you're in the Pass Culture tab, you'll see available venues based on your organization's SIREN/SIRET number. Select the venue where this specific event will take place.",
        step1: "In the Pass Culture tab, you'll see a venue selection dropdown",
        step2: "Available venues are automatically loaded based on your organization's SIREN/SIRET",
        step3: 'Select the venue where your event will take place from the dropdown',
        step4: 'Review venue details (address, accessibility, etc.) that appear on the right',
        step5: "Click 'Save Venue' to link this venue to your event",
        noVenuesInfo:
          "If no venues appear, you may need to sync with Pass Culture first (see next step) or verify that your organization's SIREN/SIRET is correctly configured and has associated venues in Pass Culture.",
      },
      eventDetails: {
        title: 'Prepare Event Details for Publishing',
        description:
          "Now that you've selected a venue, you need to prepare two key elements before you can publish your event to Pass Culture.",
        importantNote:
          'Only two fields are required at this step: event description and contact email. However, your event must also have tickets with PassCulture categories to enable publishing.',
        requiredInfo: 'Required Event Information:',
        eventDescription: 'Event Description for Pass Culture',
        eventDescriptionTip:
          'Adapt your description to appeal to young people aged 15-20. Use engaging, accessible language and highlight what makes your event special.',
        contactEmail: 'Contact Email for Pass Culture Users',
        contactEmailTip:
          'Provide a specific email address where Pass Culture users can reach you with questions about your event.',
        ticketRequirement: 'Critical Requirement - PassCulture Ticket Categories:',
        veryImportant: 'Very Important:',
        ticketWarning:
          'To publish an event to Pass Culture, your event must have tickets with PassCulture categories. The publish button will remain disabled until this condition is met.',
        createCategories: 'Create PassCulture Ticket Categories',
        createCategoriesDesc:
          "Go to your event's Tickets tab → Categories, and create at least one category with 'PassCulture Integration' enabled",
        enableIntegration: 'Enable PassCulture Integration',
        enableIntegrationDesc:
          "When creating or editing a ticket category, toggle ON the 'PassCulture Integration' setting",
        createTickets: 'Create Tickets with PassCulture Categories',
        createTicketsDesc:
          'Make sure you have active tickets assigned to these PassCulture-enabled categories',
        publishingConditions: 'Publishing Conditions:',
        condition1: 'Event description is filled and optimized for young audience',
        condition2: 'Valid contact email is provided',
        condition3: 'At least one ticket category has PassCulture Integration enabled',
        condition4: 'Event has active tickets using PassCulture categories',
        condition5: 'Event date is at least 15 days in the future',
        condition6: 'Ticket prices are within Pass Culture limits (max €300)',
        proTip:
          'If the publish button remains disabled after filling the form, check that you have created ticket categories with PassCulture Integration enabled in the Tickets tab.',
        writingTips:
          'Use keywords like "students", "young artists", mention any special prices or student discounts, and highlight social/cultural aspects that appeal to 15-20 year olds.',
        howToFillTitle: 'Comment remplir les informations requises :',
        howToFillStep1:
          "Dans l'onglet Pass Culture, vous verrez des champs de texte pour la description et l'email de contact",
        howToFillStep2:
          "Remplissez les deux champs et cliquez sur 'Enregistrer' pour stocker vos informations",
        howToFillStep3:
          "Le bouton 'Publier sur Pass Culture' sera activé lorsque toutes les conditions seront remplies",
        howToFillStep4:
          "Cliquez sur 'Publier sur Pass Culture' pour envoyer votre événement à la plateforme Pass Culture",
      },
      finalConfirmation: {
        title: 'Final Confirmation and Publishing',
        description:
          'Once all conditions are met and you click "Publish to Pass Culture", a confirmation dialog will appear for you to review all event information one final time before sending it to Pass Culture.',
        publishingDialog: 'Publishing Dialog - Final Review:',
        step1: "Click 'Publish to Pass Culture' button when it becomes enabled",
        step2: 'A confirmation dialog will open showing all event details',
        step3: 'Carefully review all information displayed in the dialog',
        step4: "Click 'Publier sur Pass Culture' to confirm and send to Pass Culture",
        informationDisplayed: 'Information Displayed in Confirmation Dialog:',
        venue: 'Venue (Lieu)',
        venueDesc: 'The Pass Culture venue ID where your event will take place',
        contactEmailInfo: 'Contact Email (Email de contact)',
        contactEmailInfoDesc: 'The contact email Pass Culture users will use to reach you',
        eventDescriptionInfo: 'Event Description (Description)',
        eventDescriptionInfoDesc: 'Preview of your Pass Culture-optimized event description',
        passCultureCategories: 'Pass Culture Categories',
        passCultureCategoriesDesc:
          'List of ticket categories that have Pass Culture integration enabled',
        imageCaption:
          'The final confirmation dialog showing all event details before publishing to Pass Culture',
        lastChanceTitle: 'Last Chance to Review:',
        lastChanceWarning:
          'This is your final opportunity to verify all information before sending your event to Pass Culture. Make sure everything is correct, especially the venue and contact email, as these cannot be easily changed after publishing.',
        afterPublishing: 'After Clicking "Publier sur Pass Culture":',
        publishingProcess: 'Publishing Process',
        publishingProcessDesc:
          'The system will send your event data to Pass Culture (may take a few seconds)',
        successConfirmation: 'Success Confirmation',
        successConfirmationDesc:
          "You'll receive a success message when the event is successfully published",
        stocksDialog: 'Stocks Dialog',
        stocksDialogDesc: 'A new dialog will open to help you add ticket stocks to Pass Culture',
        whatHappensNextTitle: 'What Happens Next:',
        whatHappensNext:
          "After successful publishing, your event will be visible in Pass Culture's integration environment for testing, or in production after moderation approval (usually 24-48 hours).",
        tipTitle: 'Tip:',
        cancelTip:
          'If you need to cancel or make changes, click "Annuler" to go back and modify your event details before publishing.',
      },
      addStocks: {
        title: 'Add Stocks to Pass Culture',
        description:
          'After successful publishing, you need to add "stocks" to Pass Culture. In Pass Culture terminology, "stocks" are the tickets that will be available for Pass Culture users to purchase.',
        vocabularyTitle: 'Pass Culture Vocabulary:',
        vocabularyNote:
          '"Stocks" = Tickets available for purchase. This step makes your Instadrink tickets with PassCulture categories available on the Pass Culture platform.',
        eventStatusAfterPublishing: 'Event Status After Publishing:',
        statusPublished: 'Status: Publié (Published)',
        statusPublishedDesc: 'Your event is now registered on Pass Culture',
        venueAndContact: 'Venue and Contact Information',
        venueAndContactDesc: 'All publication details are confirmed and stored',
        stocksWarning: 'Stocks Warning',
        stocksWarningDesc:
          "'Aucun stock n'a encore été ajouté à cet événement sur Pass Culture' - No tickets available yet",
        addingStocksProcess: 'Adding Stocks Process:',
        addStocksStep1:
          "Click 'Ajouter des stocks' button (either in the warning banner or top-right)",
        addStocksStep2: "A 4-step dialog opens: 'Ajouter des stocks à Pass Culture'",
        addStocksStep3: 'Step 1: Select PassCulture categories (automatically shown)',
        addStocksStep4: 'Follow the steps to configure and create stocks',
        step1SelectCategories: 'Step 1: Select PassCulture Categories',
        onlyPassCultureCategories: 'Only PassCulture Categories',
        onlyPassCultureCategoriesDesc:
          'Only ticket categories with PassCulture integration enabled are shown',
        preSelectedCategories: 'Pre-selected Categories',
        preSelectedCategoriesDesc:
          'Your PassCulture categories are automatically selected with checkmarks',
        continueStep: "Click 'Continuer' to proceed to stock configuration",
        imageAlt: 'Pass Culture add stocks dialog step 1',
        imageCaption: 'Step 1: Selecting PassCulture categories for stock creation',
        remainingStepsOverview: 'Remaining Steps Overview:',
        step2: 'Configurer les stocks',
        step2Desc:
          'Configure how existing Instadrink tickets will be mapped to Pass Culture stocks',
        step3: 'Confirmer et créer',
        step3Desc: 'Review and confirm the stock creation with final settings',
        step4: 'Succès',
        step4Desc: 'Stocks successfully created and available for Pass Culture users',
        whatThisAchievesTitle: 'What This Achieves:',
        whatThisAchieves:
          'After completing the stocks process, your Instadrink tickets with PassCulture categories will be available for purchase by Pass Culture users on their platform.',
        importantWithoutStocks:
          'Without adding stocks, your event will be published on Pass Culture but no tickets will be available for purchase. Always complete this step after publishing.',
      },
    },

    proTip: 'Pro Tip:',
    writingTips: 'Writing Tips for Young Audience:',

    venuesOfferers: {
      title: 'Understanding Venues and Offerers',
      offerer: {
        title: 'Offerer',
        description:
          'The offerer represents your organization/business entity in Pass Culture. It contains your business information and is linked to your SIREN number.',
        includes: 'Offerer includes:',
        item1: 'Business name and legal information',
        item2: 'SIREN number',
        item3: 'Account creation date',
        item4: 'Validation status',
      },
      venues: {
        title: 'Venues',
        description:
          'Venues are the physical locations where your events take place. Each venue has specific information and accessibility details.',
        includes: 'Each venue includes:',
        item1: 'Venue name and address',
        item2: 'SIRET number (if applicable)',
        item3: 'Accessibility information',
        item4: 'Activity domain',
      },
    },

    environments: {
      title: 'Integration vs Production Environment',
      features: 'Features:',
      warningNote:
        'Always test thoroughly in the integration environment before requesting production access. The Pass Culture team will review your integration and may require changes before approval.',
      integration: {
        label: 'Integration',
        title: 'Testing Environment',
        description:
          "Used for testing and development. Your events won't be visible to real Pass Culture users.",
        feature1: 'Safe testing environment',
        feature2: 'No real money transactions',
        feature3: 'Events not visible to public',
        feature4: 'Full API functionality',
      },
      production: {
        label: 'Production',
        title: 'Live Environment',
        description:
          'The live environment where your events are visible to real Pass Culture users.',
        feature1: 'Events visible to public',
        feature2: 'Real money transactions',
        feature3: 'Full Pass Culture integration',
        feature4: 'Requires Pass Culture approval',
      },
    },

    troubleshooting: {
      title: 'Troubleshooting Common Issues',
      solutions: 'Solutions:',
      noVenues: {
        title: '"No venues found" error',
        description:
          "This usually means your SIREN/SIRET is not found in Pass Culture or doesn't have associated venues.",
        solution1: 'Verify your SIREN/SIRET number is correct',
        solution2: "Check that you've completed venue setup in Pass Culture Pro",
        solution3: 'Contact Pass Culture support to verify your account status',
      },
      syncFailed: {
        title: '"Sync failed" error',
        description:
          'Network or authentication issues preventing synchronization with Pass Culture API.',
        solution1: 'Check your internet connection and try again',
        solution2: 'Wait a few minutes and retry the sync',
        solution3: 'Contact Instadrink support if the issue persists',
      },
      needSiren: {
        title: '"Need SIREN or SIRET" warning',
        description: "Your organization profile doesn't have a SIREN or SIRET number configured.",
        solution1: 'Go to Organization Settings → General Information',
        solution2: 'Add your 9-digit SIREN or 14-digit SIRET number',
        solution3: 'Save settings and return to Pass Culture integration',
      },
      eventsNotAppearing: {
        title: 'Events not appearing in Pass Culture',
        description: 'Your events are created but not visible on the Pass Culture platform.',
        solution1:
          "Ensure you've selected a Pass Culture venue for your event in the event's Pass Culture tab",
        solution2: 'Check that your event meets Pass Culture eligibility criteria',
        solution3: "Verify you're in production environment (not integration)",
        solution4: 'Wait 24-48 hours for Pass Culture moderation',
      },
    },

    bestPractices: {
      title: 'Best Practices',
      regularSync: {
        title: 'Regular Syncing',
        description:
          "Sync your venues regularly to ensure you have the latest information from Pass Culture, especially if you've added new venues or updated existing ones.",
      },
      testThoroughly: {
        title: 'Test Thoroughly',
        description:
          'Always test your events in the integration environment before going live. This helps catch issues early and ensures a smooth experience for users.',
      },
      targetAudience: {
        title: 'Target Audience',
        description:
          'Remember that Pass Culture users are aged 15-20. Tailor your event descriptions and marketing to appeal to this younger demographic.',
      },
    },

    eventRequirements: {
      title: 'Pass Culture Event Requirements',
      description:
        'Not all events are eligible for Pass Culture. Make sure your events meet these criteria:',
      eligible: {
        title: 'Eligible Event Types',
        concerts: 'Concerts and live music performances',
        theater: 'Theater shows and dramatic performances',
        artExhibitions: 'Art exhibitions and cultural workshops',
        literaryEvents: 'Literary events and book presentations',
        photography: 'Photography and multimedia exhibitions',
        cinema: 'Cinema screenings and film festivals',
      },
      nonEligible: {
        title: 'Non-Eligible Event Types',
        sports: 'Sports events and competitions',
        business: 'Business conferences and seminars',
        privateParties: 'Private parties and celebrations',
        commercial: 'Commercial product launches',
        religious: 'Religious or political events',
        educational: 'Educational courses or training',
      },
      additional: {
        title: 'Additional Requirements',
        timing: 'Timing',
        timing1: 'Events must be published at least 15 days before the event date',
        timing2: 'Booking must close at least 2 hours before event start',
        pricing: 'Pricing',
        pricing1: 'Maximum ticket price: €300',
        pricing2: 'Free events are allowed and encouraged',
      },
    },

    support: {
      title: 'Support and Resources',
      links: {
        title: 'Useful Links',
        pro: 'Pass Culture Pro',
        proDesc: 'https://passculture.pro - Main platform for cultural providers',
        documentation: 'Pass Culture Documentation',
        documentationDesc: 'Official API documentation and guidelines',
        app: 'Pass Culture App',
        appDesc: 'Download the app to see how your events appear to users',
      },
      help: {
        title: 'Get Help',
        instadrink: 'Instadrink Support',
        instadrinkDesc: 'support@instadrink.com - For technical integration issues',
        passculture: 'Pass Culture Support',
        passcultureDesc: 'Contact through Pass Culture Pro platform for account issues',
        liveChat: 'Live Chat',
        liveChatDesc: 'Use the chat widget in your Instadrink dashboard',
      },
    },

    faq: {
      title: 'Frequently Asked Questions',
      q1: {
        question: 'Q: How long does it take to get approved for Pass Culture?',
        answer:
          'A: The approval process typically takes 2-4 weeks after submitting all required documents. Testing and validation may add another 1-2 weeks before production approval.',
      },
      q2: {
        question: "Q: Can I use Pass Culture if I'm not based in France?",
        answer:
          'A: Pass Culture is specifically for cultural providers operating in France. You need a French SIREN/SIRET number and your events must take place in France.',
      },
      q3: {
        question: 'Q: What happens if my event is cancelled?',
        answer:
          'A: If you cancel an event, Pass Culture users will be automatically refunded. You should cancel the event in both Instadrink and notify Pass Culture as soon as possible.',
      },
      q4: {
        question: 'Q: How do I receive payments from Pass Culture bookings?',
        answer:
          "A: Pass Culture handles payments directly and transfers funds to your bank account according to their payment schedule. You'll set up banking details in your Pass Culture Pro account.",
      },
      q5: {
        question: "Q: Can I modify events after they're published to Pass Culture?",
        answer:
          "A: Yes, but changes are subject to Pass Culture's policies. Major changes like date, time, or venue may require re-approval. Price increases are generally not allowed after publication.",
      },
    },

    readyToStart: {
      title: 'Ready to Get Started?',
      description:
        "Now that you understand how Pass Culture integration works, you're ready to start the setup process! Begin by ensuring you have your SIREN or SIRET number, then follow the step-by-step guide above.",
      button: 'Start Integration Setup',
    },
  },

  dashboard: 'Dashboard',
  organizers: 'Organizers',
  organizerDetails: 'Organizer Details',
  generalInfo: 'General Info',
  backToOrganizers: 'Back to Organizers',
  backToOrganizer: 'Back to Organizer',
  organizerNotFound: 'Organizer not found',
  failedToFetchOrganizer: 'Failed to fetch organizer data',

  // Integration specific
  integrations: 'Integrations',
  integrationsPageDescription:
    'Connect your organizer to external services to enhance your events and reach more customers.',
  comingSoon: 'Coming Soon',
  integrationComingSoon:
    'The {name} integration is currently in development and will be available soon.',

  // Integration descriptions
  passCultureIntegrationDescription:
    'Pass Culture is a mobile application and website that offers €300 to 18-year-olds to spend on cultural goods and experiences. Connect your organizer to automatically import venues and publish your events.',
  ticketingIntegrationDescription:
    'Connect your organizer to popular ticketing platforms to synchronize event data, manage ticket sales, and track attendance across multiple channels.',
  crmIntegrationDescription:
    'Integrate with Customer Relationship Management systems to manage your customer base, track communication history, and build marketing campaigns for your events.',

  // Tab labels
  ticketing: 'Ticketing',

  // Pass Culture specific translations
  passCultureIntegration: 'Pass Culture Integration',
  identifier: 'Identifier',
  noIdentifier: 'No identifier configured',
  lastSynced: 'Last synchronized',
  venues: 'Venues',
  offerer: 'Offerer',
  syncWithPassCulture: 'Sync with Pass Culture',
  passCultureVenues: 'Pass Culture Venues',
  passCultureOfferer: 'Pass Culture Offerer',
  syncResults: 'Synchronization Results',
  noVenuesFound: 'No venues found',
  noOffererData: 'No offerer data available',
  syncedVenues: 'Successfully synced {{count}} venues',
  passCultureSyncSuccess: 'Successfully synchronized {{count}} venues with Pass Culture',
  passCultureSyncFailed: 'Failed to synchronize with Pass Culture',
  syncFailed: 'Synchronization failed',
  needSirenOrSiret: 'Organizer needs either a SIREN or SIRET number to sync with Pass Culture',
  close: 'Close',
  never: 'Never',
  siren: 'SIREN',
  createdAt: 'Created at',
  additionalInfo: 'Additional Information',
  notAvailable: 'Not available',
  goodies: {
    // Section Headers
    section: {
      title: 'Event Merchandise',
      description:
        'Manage merchandise items that customers can purchase when booking tickets for this event.',
    },

    // Actions
    actions: {
      new: 'Add Merchandise',
      edit: 'Edit Merchandise',
      add: 'Add Merchandise',
      save: 'Save Changes',
      create: 'Create Merchandise',
      delete: 'Delete Merchandise',
      delete_confirm:
        'Are you sure you want to delete this merchandise item? This action cannot be undone.',
      manage: 'Manage Merchandise',
      hide: 'Hide Merchandise',
      clear_cart: 'Clear Cart',
      checkout: 'Checkout',
      add_to_cart: 'Add to Cart',
      adding: 'Adding...',
      remove: 'Remove',
      close: 'Close',
      search: 'Search merchandise...',
    },

    // Table Headers
    table: {
      name: 'Name',
      price: 'Price',
      stock: 'Stock',
      active: 'Active',
      selected: 'selected',
      search: 'Search merchandise...',
    },

    // Form Fields
    form: {
      name: 'Name',
      description: 'Description',
      price: 'Price',
      stock: 'Stock',
      image: 'Image',
      active: 'Active',
      in_stock: 'In Stock',
      out_of_stock: 'Out of Stock',
      quantity: 'Quantity',
      sizes_available: 'sizes available',
    },

    // Cart
    cart: {
      title: 'Your Merchandise',
      subtotal: 'Subtotal',
      checkout_notice: 'Merchandise will be added to your ticket reservation.',
      increase_quantity: 'Increase Quantity',
      decrease_quantity: 'Decrease Quantity',
      open: 'Open Merchandise Cart',
    },

    // Tooltips
    tooltips: {
      name: 'Enter the name of the merchandise item',
      description: 'Provide a detailed description of the merchandise item',
      price: 'Set the price for this merchandise item',
      stock: 'Enter the available quantity of this merchandise',
      image: 'Upload an image of the merchandise item',
      active: 'Toggle to make this merchandise item available for purchase',
    },

    // Errors
    errors: {
      loading: 'Error loading merchandise items',
      none_available: 'No merchandise available for this event',
    },

    // Language tabs
    languages: 'Translation tabs (English, French, Spanish, Portuguese, German)',
  },
  participantInfos: {
    know_from_attendees: 'Know from attendees',
    know_from_attendees_description:
      'Select how you want to collect information about how attendees found out about your event.',
    add_custom_field: 'Add Custom Field',
    field_name: 'Field Name',
    field_type: 'Field Type',
    add_field: 'Add Field',
    options: 'Options',
    add_option: 'Add Option',
    add: 'Add',
    Text: 'Text',
    Number: 'Number',
    Email: 'Email',
    Phone: 'Phone',
    Date: 'Date',
    'Multiple Choice': 'Multiple Choice',
    Dropdown: 'Dropdown',
    Checkbox: 'Checkbox',
    type: 'Type',
    Edit_data_success: 'Data successfully updated!',
    Edit_data_failed: 'Failed to update data!',
    options_for: 'Options for',
    enter_option_placeholder: 'Enter an option and press Enter or Add',
    multiple_choice_helper_text: 'Attendees will be able to select one option from the list.',
    dropdown_helper_text: 'Attendees will see a dropdown menu to select one option.',
    checkbox_helper_text: 'Attendees will be able to select multiple options from the list.',
    'Single Choice': 'Single Choice',
    single_choice_explanation: 'Attendees will be able to select only ONE option from the list.',
    multiple_choice_explanation: 'Attendees will be able to select MULTIPLE options from the list.',
    minimum_options_warning: 'You need at least 2 options for this question type.',
  },
  'Multi-day Festival Ticket': 'Multi-day Festival Ticket',
  'Allow ticket to be validated once per festival day':
    'Allow ticket to be validated once per festival day',
  'Multi-day Festival Configuration': 'Multi-day Festival Configuration',
  'This ticket can be validated once per festival day. Validations reset daily at the specified time.':
    'This ticket can be validated once per festival day. Validations reset daily at the specified time.',
  Example: 'Example',
  'Festival June 10-13, reset at 02:00 means:': 'Festival June 10-13, reset at 02:00 means:',
  'Day 1: June 10 from event start until June 11 02:00':
    'Day 1: June 10 from event start until June 11 02:00',
  'Day 2: June 11 02:00 until June 12 02:00': 'Day 2: June 11 02:00 until June 12 02:00',
  'Day 3: June 12 02:00 until June 13 02:00': 'Day 3: June 12 02:00 until June 13 02:00',
  'Day 4: June 13 02:00 until event end': 'Day 4: June 13 02:00 until event end',
  'Daily Reset Time': 'Daily Reset Time',
  'Choose when daily validations reset (24h format). Common times: 02:00, 04:00, 06:00':
    'Choose when daily validations reset (24h format). Common times: 02:00, 04:00, 06:00',
  'Invalid time format. Use HH:MM (24h format)': 'Invalid time format. Use HH:MM (24h format)',
  'Bus Tickets View': 'Bus Tickets View',
  export_bus_tickets: 'Export Bus Tickets',
  no_bus_tickets_to_export: 'No bus tickets to export',
  no_bus_tickets_to_export_for_status: 'No bus tickets to export for status: {{status}}',
  // Goodies View
  'Goodies View': 'Goodies View',
  export_goodies: 'Export Goodies',
  no_goodies_to_export: 'No goodies to export',
  no_goodies_to_export_for_status: 'No goodies to export for status: {{status}}',
  Item: 'Item',
  'Order Date': 'Order Date',
  // Goodies Export Options
  export_csv_all: 'Export CSV - All Orders',
  export_csv_confirmed: 'Export CSV - Confirmed Orders',
  export_pdf_provider_all: 'Provider Report PDF - All Orders',
  export_pdf_provider_confirmed: 'Provider Report PDF - Confirmed Orders',
  // Bus Ticket Fields
  departure: 'Departure',
  scanned: 'Scanned',
  not_scanned: 'Not Scanned',
  // Bus Ticket Actions
  view_reservation_details: 'View Reservation Details',
  send_email_to_reservation: 'Send Email to Reservation',
  unknown: 'Unknown',
  confirm_bus_refund: 'Confirm Bus Ticket Refund',
  bus_refund_confirmation_message:
    'Are you sure you want to refund this bus ticket? This action cannot be undone.',
  bus_ticket_details: 'Bus Ticket Details',
  refund_bus_ticket: 'Refund Bus Ticket',
  only_confirmed_bus_tickets_can_be_refunded: 'Only confirmed bus tickets can be refunded',
  cannot_refund_free_ticket: 'Cannot refund free tickets',
  bus_ticket_refunded_successfully: 'Bus ticket refunded successfully',
  failed_to_refund_bus_ticket: 'Failed to refund bus ticket',
  scanningAnalytics: 'Scanning Analytics',
  noScanningData: 'No scanning data available',
  totalValidations: 'Total Validations',
  validationRate: 'Validation Rate',
  uniqueScanners: 'Unique Scanners',
  avgValidationsPerTicket: 'Avg. Validations/Ticket',
  multipleValidatedTickets: 'Multiple Validated Tickets',
  dailyValidationInsights: 'Daily Validation Insights',
  dailyBreakdown: 'Daily Breakdown',
  uniqueTickets: 'Unique Tickets',
  singleValidations: 'Single Validations',
  multipleValidations: 'Multiple Validations',
  ticketTypeValidationStats: 'Ticket Type Validation Stats',
  ticketTypeValidationBreakdown: 'Ticket Type Validation Breakdown',
  ticketType: 'Ticket Type',
  multipleValidationRate: 'Multiple Validation Rate',
  dailyValidationTrends: 'Daily Validation Trends',
  hourlyValidationPattern: 'Hourly Validation Pattern',
  scannerDailyActivity: 'Scanner Daily Activity',
  validationEfficiencyMetrics: 'Validation Efficiency Metrics',
  maxValidationsPerTicket: 'Max Validations/Ticket',
  activeDays: 'Active Days',
  avgValidationsPerDay: 'Avg. Validations/Day',
  detailedValidationHistory: 'Detailed Validation History',
  firstValidation: 'First Validation',
  lastValidation: 'Last Validation',
  multipleValidationsDetails: 'Multiple Validations Details',
  ticketsWithMultipleValidationsExplanation:
    'Tickets that have been validated multiple times (common in multi-day festivals)',
  ticketStatusDistribution: 'Ticket Status Distribution',
  scannerActivity: 'Scanner Activity',
  detailedStatusBreakdown: 'Detailed Status Breakdown',
  dailyValidations: 'Daily Validations',
  hourlyValidations: 'Hourly Validations',
  ticketId: 'Ticket ID',
  clientName: 'Client Name',
  validations: 'Validations',
  lastScanner: 'Last Scanner',
  physicalSale: 'Physical Sale',
  salesAnalytics: 'Sales Analytics',
  eventStatistics: 'Event Statistics',
  ticketsSold: 'Tickets Sold',
  validatedTickets: 'Validated Tickets',
  quickInsights: 'Quick Insights',
  eventStatus: 'Event Status',
  ticketTypes: 'Ticket Types',
  types: 'Types',
  quantities: 'Quantities',
  revenue: 'Revenue',
  timeline: 'Timeline',
  edited: 'Edited',

  // Music Studio Service Management
  studio: {
    customization: {
      title: 'Studio Customization',
      subtitle: 'Customize how your studio appears to clients and visitors',
      resetTooltip: 'Reset to default settings',
      previewTooltip: 'Preview customization',
      saveChanges: 'Save Changes',
      enableCustomization: 'Enable Customization',
      enableDescription: 'When enabled, your custom settings will be applied to the studio page',
      choosePersonality: 'Choose Studio Personality',
      tabs: {
        layout: 'Layout',
        theme: 'Theme',
        content: 'Content',
      },
      layout: {
        heroStyle: 'Hero Style',
        heroStyles: {
          fullscreen: 'Fullscreen',
          banner: 'Banner',
          split: 'Split',
          minimal: 'Minimal',
        },
        logoPosition: 'Logo Position',
        logoPositions: {
          overlayLeft: 'Overlay Left',
          center: 'Center',
          above: 'Above',
          side: 'Side',
        },
        ctaPosition: 'Call-to-Action Position',
        ctaPositions: {
          hero: 'In Hero',
          below: 'Below Hero',
          floating: 'Floating',
          multiple: 'Multiple Positions',
        },
        sectionOrder: 'Section Order',
        sectionOrderDescription: 'The order in which sections appear on your studio page',
      },
    },
    theme: {
      title: 'Studio Theme',
      subtitle: "Manage your studio's visual identity with custom logo and cover images",
      logoSection: {
        title: 'Studio Logo',
        description: 'Upload your studio logo. Recommended size: 256x256px, max 2MB',
        changeLogo: 'Change Logo',
        uploadLogo: 'Upload Logo',
        removeLogo: 'Remove Logo',
        clickToPreview: 'Click to preview',
      },
      coverSection: {
        title: 'Cover Image',
        description: 'Upload your studio cover image. Recommended size: 1200x400px, max 5MB',
        changeCoverImage: 'Change Cover Image',
        uploadCoverImage: 'Upload Cover Image',
        removeCoverImage: 'Remove Cover Image',
      },
      guidelines: {
        title: 'Theme Guidelines',
        logoRequirements: 'Logo Requirements',
        logoSpecs: {
          squareFormat: 'Square format (1:1 ratio) recommended',
          minMaxSize: 'Minimum 256x256px, maximum 512x512px',
          format: 'PNG or JPG format',
          maxFileSize: 'Maximum file size: 2MB',
          transparentBg: 'Transparent background preferred for PNG',
        },
        coverRequirements: 'Cover Image Requirements',
        coverSpecs: {
          landscapeFormat: 'Landscape format (3:1 ratio) recommended',
          minSize: 'Minimum 1200x400px',
          format: 'PNG or JPG format',
          maxFileSize: 'Maximum file size: 5MB',
          highQuality: 'High quality images showcase better',
        },
      },
      messages: {
        logoSizeError: 'Logo file size must be less than 2MB',
        coverSizeError: 'Cover image file size must be less than 5MB',
        invalidImageFile: 'Please select a valid image file',
        logoUpdated: 'Logo updated successfully!',
        logoUpdateFailed: 'Failed to update logo',
        coverUpdated: 'Cover image updated successfully!',
        coverUpdateFailed: 'Failed to update cover image',
        confirmRemoveLogo: 'Are you sure you want to remove the studio logo?',
        confirmRemoveCover: 'Are you sure you want to remove the cover image?',
        logoRemoved: 'Logo removed successfully!',
        logoRemoveFailed: 'Failed to remove logo',
        coverRemoved: 'Cover image removed successfully!',
        coverRemoveFailed: 'Failed to remove cover image',
      },
      preview: {
        logoTitle: 'Logo Preview',
        coverTitle: 'Cover Image Preview',
        close: 'Close',
      },
    },
    showcase: {
      title: 'Music Showcase',
      settings: {
        title: 'Music Showcase Settings',
        subtitle: "Configure your studio's music showcase for clients",
        saveSettings: 'Save Settings',
        enableShowcase: 'Enable Music Showcase',
        enableDescription:
          'When enabled, your music showcase will be visible to clients on your studio profile',
        showcaseTitle: 'Showcase Title',
        showcaseTitlePlaceholder: 'e.g., Our Latest Productions',
        showcaseDescription: 'Showcase Description',
        showcaseDescriptionPlaceholder: 'Describe your music showcase...',
      },
      tracks: {
        title: 'Music Tracks',
        subtitle: "Add music tracks to showcase your studio's work",
        addTrack: 'Add Track',
        addFirstTrack: 'Add First Track',
        editTrack: 'Edit Track',
        noTracksYet: 'No tracks added yet. Add your first track to get started!',
        enableShowcaseFirst: 'Enable the music showcase above to start adding tracks',
        trackCount: 'Music Tracks ({{count}})',
        hidden: 'Hidden',
        by: 'by',
      },
      trackDialog: {
        addTitle: 'Add Track',
        editTitle: 'Edit Track',
        trackTitle: 'Track Title *',
        trackTitlePlaceholder: 'Enter track title',
        artist: 'Artist',
        artistPlaceholder: 'Artist or band name',
        platform: 'Platform *',
        url: 'URL *',
        description: 'Description',
        descriptionPlaceholder: 'Optional description or notes about this track',
        cancel: 'Cancel',
        add: 'Add',
        update: 'Update',
        addTrackButton: 'Add Track',
        updateTrackButton: 'Update Track',
      },
      platforms: {
        youtube: 'YouTube',
        spotify: 'Spotify',
        soundcloud: 'SoundCloud',
        apple_music: 'Apple Music',
        bandcamp: 'Bandcamp',
        other: 'Other',
      },
      urlHints: {
        youtube:
          'e.g., https://www.youtube.com/watch?v=dQw4w9WgXcQ or https://youtu.be/dQw4w9WgXcQ',
        spotify: 'e.g., https://open.spotify.com/track/4uLU6hMCjMI75M1A2tKUQC',
        soundcloud: 'e.g., https://soundcloud.com/artist/track-name',
        apple_music: 'e.g., https://music.apple.com/us/album/song-name/id123456789?i=123456789',
        bandcamp: 'e.g., https://artist.bandcamp.com/track/song-name',
        other: 'Enter any music platform URL',
      },
      actions: {
        openLink: 'Open link',
        hideTrack: 'Hide track',
        showTrack: 'Show track',
        editTrack: 'Edit track',
        removeTrack: 'Remove track',
      },
      messages: {
        settingsSaved: 'Showcase settings saved successfully!',
        settingsSaveFailed: 'Failed to save showcase settings',
        enterTitle: 'Please enter a track title',
        enterUrl: 'Please enter a track URL',
        invalidUrl: 'Invalid {{platform}} URL format',
        trackUpdated: 'Track updated successfully!',
        trackAdded: 'Track added successfully!',
        trackSaveFailed: 'Failed to save track',
        confirmRemove: 'Are you sure you want to remove "{{title}}" from the showcase?',
        trackRemoved: 'Track removed successfully!',
        trackRemoveFailed: 'Failed to remove track',
        trackHidden: 'Track hidden successfully!',
        trackShown: 'Track shown successfully!',
        trackToggleFailed: 'Failed to toggle track visibility',
        tracksReordered: 'Tracks reordered successfully!',
        tracksReorderFailed: 'Failed to reorder tracks',
      },
    },
    availability: {
      title: 'Studio Availability',
      subtitle: 'Configure your studio working hours, booking time slots, and availability rules',
      loading: 'Loading availability settings...',
      loadError: 'Failed to load availability settings. Please try refreshing the page.',
      tabs: {
        workingHours: 'Working Hours',
        bookingRules: 'Booking Rules',
        timeSlots: 'Time Slots',
      },
      daysOfWeek: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
      },
      workingHours: {
        title: 'Weekly Schedule',
        description:
          'Set your studio operating hours for each day of the week. Enable 24-hour mode or set cross-midnight schedules (e.g., 22:00 to 06:00 next day)',
        startTime: 'Start Time',
        endTime: 'End Time',
        is24Hours: '24h',
        nextDay: 'next day',
        crossMidnightSchedule: 'Cross-midnight schedule:',
      },
      crossDayPolicy: {
        title: 'Cross-Day Booking Policy',
        enableCrossDayBookings: 'Enable Cross-Day Bookings',
        enableDescription: 'Allow bookings that span across midnight (e.g., 23:00 PM to 2:00 AM)',
        maxCrossDayHours: 'Max Cross-Day Hours',
        maxCrossDayHoursHelp: 'Maximum hours a booking can span across days',
        allowWeekendCrossover: 'Allow Weekend Crossover',
        allowWeekendCrossoverHelp: 'Allow bookings to cross from weekend to weekday or vice versa',
        requireSameDayStart: 'Require Same Day Start',
        requireSameDayStartHelp: 'Booking must start and end on the same calendar day',
      },
      bookingRules: {
        title: 'Booking Configuration',
        description: 'Configure booking rules and restrictions',
        advanceBookingDays: 'Advance Booking Days',
        advanceBookingDaysHelp: 'How many days in advance can clients book',
        minBookingNotice: 'Minimum Notice (hours)',
        minBookingNoticeHelp: 'Minimum hours before booking',
        maxBookingDuration: 'Max Session Duration (minutes)',
        maxBookingDurationHelp: 'Maximum booking duration',
        bufferTime: 'Buffer Time (minutes)',
        bufferTimeHelp: 'Break time between bookings',
        autoApproveBookings: 'Auto-approve bookings',
        autoApproveBookingsHelp: 'Automatically approve booking requests without manual review',
        allowBackToBackBookings: 'Allow back-to-back bookings',
        allowBackToBackBookingsHelp: 'Allow bookings to be scheduled consecutively',
      },
      timeSlots: {
        title: 'Time Slot Configuration',
        description: 'Configure booking time slots and intervals',
        timeSlotUnit: 'Time Slot Unit',
        timeSlotDuration: 'Default Slot Duration (minutes)',
        timeSlotDurationHelp: 'Default duration for booking slots',
        info: 'Time slots will be generated based on your working hours and selected time unit. Clients can select from available slots when booking.',
        units: {
          '15min': '15 minutes',
          '30min': '30 minutes',
          '1hr': '1 hour',
        },
      },
      validation: {
        advanceBookingDaysRequired: 'Advance booking days is required',
        minBookingNoticeRequired: 'Minimum booking notice is required',
        maxBookingDurationRequired: 'Maximum booking duration is required',
        timeSlotDurationRequired: 'Time slot duration is required',
        bufferTimeRequired: 'Buffer time is required',
      },
      actions: {
        reset: 'Reset',
        saveSettings: 'Save Settings',
      },
      messages: {
        settingsSaved: 'Availability settings saved successfully!',
        saveFailed: 'An error occurred. Please try again.',
      },
    },
    settings: {
      title: 'General Settings',
      subtitle: 'Configure your studio settings and preferences',
      tabs: {
        general: 'General',
        bookingRules: 'Booking Rules',
        pricingPayment: 'Pricing & Payment',
        notifications: 'Notifications',
        studioBusiness: 'Studio Business',
      },
      general: {
        studioName: 'Studio Name',
        studioNameHelp: 'The name of your studio or organization',
        emailAddress: 'Email Address',
        phoneNumber: 'Phone Number',
        address: 'Address',
        emailAddressHelp: 'Primary contact email for your studio',
        description: 'Description',
        saveButton: 'Save General Settings',
        phoneNumberHelp: 'Primary contact phone number',
        addressHelp: 'Physical address of your studio',
        descriptionHelp: 'Brief description about your studio and services',
        noLocationsFound: 'No locations found',
      },
      bookingRules: {
        title: 'Booking Rules',
        description: 'Configure booking rules and restrictions for your studio',
        requiresApproval: 'Require Manual Approval',
        requiresApprovalHelp: 'All bookings require owner approval before confirmation',
        cancellationPolicy: 'Allow Cancellation',
        cancellationPolicyHelp: 'Clients can cancel their bookings within allowed time window',
        cancellationWindow: 'Cancellation Window (hours)',
        cancellationWindowHelp: 'Hours before booking start time that cancellation is allowed',
        maxAdvanceBooking: 'Maximum Advance Booking (days)',
        maxAdvanceBookingHelp: 'Maximum number of days in advance that bookings can be made',
        minAdvanceBooking: 'Minimum Advance Notice (hours)',
        minAdvanceBookingHelp: 'Minimum hours in advance that bookings must be made',
        minBookingDuration: 'Minimum Booking Duration (minutes)',
        minBookingDurationHelp: 'Minimum duration allowed for a single booking session',
        maxBookingDuration: 'Maximum Booking Duration (minutes)',
        maxBookingDurationHelp: 'Maximum duration allowed for a single booking session',
        bookingSpacingTitle: 'Booking Spacing & Approval',
        allowBackToBack: 'Allow Back-to-Back Bookings',
        allowBackToBackHelp: 'Allow bookings to start immediately after previous booking ends',
        bufferTime: 'Buffer Time Between Bookings (minutes)',
        requireApproval: 'Require approval for bookings',
        requireApprovalHelp: 'Bookings need approval before confirmation',
        allowCancellation: 'Allow booking cancellation',
        allowCancellationHelp: 'Clients can cancel their bookings',
        cancellationDeadline: 'Cancellation deadline (hours)',
        maxBookingDays: 'Max booking days in advance',
        paymentTitle: 'Payment Settings',
        requirePaymentUpfront: 'Require payment upfront',
        requirePaymentUpfrontHelp: 'Clients must pay before booking confirmation',
        depositPercentage: 'Deposit percentage (%)',
        acceptedPaymentMethods: 'Accepted Payment Methods',
        cash: 'Cash',
        cashHelp: 'Accept cash payments',
        card: 'Card',
        cardHelp: 'Accept card payments',
        online: 'Online',
        onlineHelp: 'Accept online payments',
        saveButton: 'Save Booking Rules',
        bufferTimeHelp: 'Minimum time gap required between consecutive bookings',
        saveSuccess: 'Booking rules saved successfully',
        saveFailed: 'Failed to save booking rules',
      },
      paymentSettings: {
        title: 'Payment Settings',
        subtitle: 'Configure how payments are collected for bookings',
        paymentMode: 'Payment Mode',
        paymentModeRequired: 'Payment mode is required',
        invalidPaymentMode: 'Invalid payment mode',

        // Payment Modes
        manualMode: 'Manual Confirmation (No Payment Required)',
        manualModeDescription: 'Bookings are confirmed without payment. Owner confirms manually.',
        fullMode: 'Full Payment to Confirm Booking',
        fullModeDescription: 'Customer must pay 100% upfront to confirm the booking.',
        depositMode: 'Deposit Payment',
        depositModeDescription: 'Customer pays a percentage deposit. Remaining balance due later.',
        holdMode: 'Payment Hold (Pre-authorization)',
        holdModeDescription:
          'Place a hold on customer payment method. Charge after owner confirms booking.',

        // Deposit Settings
        depositConfiguration: 'Deposit Configuration',
        depositConfigurationHelp:
          'Configure deposit percentage and optional advance booking restrictions',
        depositPercentage: 'Deposit Percentage',
        depositPercentageHelp: 'Percentage of total price required as deposit (0-100%)',
        depositPercentageMin: 'Deposit percentage must be at least 0%',
        depositPercentageMax: 'Deposit percentage cannot exceed 100%',
        depositPercentageRequired: 'Deposit percentage is required for deposit mode',

        restrictDepositToAdvanceDays: 'Restrict Deposit to Advance Bookings',
        restrictDepositToAdvanceDaysHelp:
          'Only require deposit for bookings made X days in advance',
        depositOnlyForAdvanceDays: 'Deposit Required For Advance Days',
        depositOnlyForAdvanceDaysHelp:
          'Require deposit only for bookings made this many days in advance',
        depositOnlyForAdvanceDaysMin: 'Days must be 0 or greater',
        depositOnlyForAdvanceDaysRequired: 'Please specify the number of advance days',

        // Payment Hold
        paymentHoldTitle: 'Payment Authorization Hold',
        paymentHoldDescription:
          "A pre-authorization hold will be placed on the customer's payment method. The amount will not be charged until you manually confirm the booking. The hold typically expires after 7 days if not confirmed.",

        // Payment Methods
        acceptedMethodsTitle: 'Accepted Payment Methods',
        acceptedMethodsSubtitle: 'Select which payment methods you accept',
        atLeastOneMethodRequired:
          'At least one payment method must be selected when payment is required',

        acceptCash: 'Cash',
        acceptCashHelp: 'Accept cash payments on-site',
        acceptCard: 'Card (On-site)',
        acceptCardHelp: 'Accept card payments on-site',
        acceptOnlinePayment: 'Online Payment',
        acceptOnlinePaymentHelp: 'Accept online payments via Stripe',

        // Stripe
        stripeIntegrationTitle: 'Stripe Integration Required',
        stripeIntegrationDescription:
          'To accept online payments, you need to connect your Stripe account. Contact support to set up Stripe Connect integration.',
        stripeAccountIdRequired: 'Stripe account ID is required for online payments',

        // Messages
        saveButton: 'Save Payment Settings',
        saveSuccess: 'Payment settings saved successfully',
        saveFailed: 'Failed to save payment settings',
        applyToNewBookings:
          'Payment settings will be applied to all new bookings. Existing bookings remain unchanged.',

        // Days
        days: 'days',
      },
      notifications: {
        channelsTitle: 'Notification Channels',
        channelsSubtitle: 'Choose how you want to receive notifications',
        title: 'Notification Settings',
        description: 'Configure how you receive notifications about bookings and activity',
        emailNotifications: 'Email Notifications',
        smsNotifications: 'SMS Notifications',
        emailNotificationsHelp: 'Receive notifications via email',
        smsNotificationsHelp: 'Receive notifications via SMS',
        whatsappNotifications: 'WhatsApp Notifications',
        whatsappNotificationsHelp: 'Receive notifications via WhatsApp',
        typesTitle: 'Notification Types',
        typesSubtitle: 'Select which events you want to be notified about',
        customerNotifications: 'Customer Notifications',
        bookingConfirmation: 'Booking Confirmation',
        bookingConfirmationHelp: 'Send confirmation when booking is made',
        bookingReminder: 'Booking Reminder',
        bookingReminderHelp: 'Send reminder before booking starts',
        cancellationNotice: 'Cancellation Notice',
        cancellationNoticeHelp: 'Send notice when booking is cancelled',
        studioOwnerAlerts: 'Studio Owner Alerts',
        newBookingAlert: 'New Booking Alert',
        newBookingAlertHelp: 'Get notified when new bookings are made',
        cancellationAlert: 'Cancellation Alert',
        cancellationAlertHelp: 'Get notified when bookings are cancelled',
        ownerNotifications: 'Studio Owner Alerts',
        notifyOnBooking: 'Booking Confirmation',
        notifyOnBookingHelp: 'Send confirmation when booking is made',
        notifyBeforeSession: 'Booking Reminder',
        notifyBeforeSessionHelp: 'Send reminder before booking starts',
        notifyOnStatusChange: 'Cancellation Notice',
        notifyOnStatusChangeHelp: 'Send notice when booking is cancelled or status changes',
        notifyOwnerOnBooking: 'New Booking Alert',
        notifyOwnerOnBookingHelp: 'Get notified when new bookings are made',
        notifyOwnerOnCancellation: 'Cancellation Alert',
        notifyOwnerOnCancellationHelp: 'Get notified when bookings are cancelled',
        saveButton: 'Save Notification Settings',
      },
      studioBusiness: {
        visibilityTitle: 'Studio Visibility',
        visibilitySubtitle:
          'Control whether your studio appears in public listings and search results',
        title: 'Studio Business Settings',
        description: "Manage your studio's public presence and visibility",

        publiclyVisible: 'Publicly Visible',
        publiclyVisibleOn: 'Your studio appears in public listings and can be found by clients',
        publiclyVisibleOff:
          'Your studio is hidden from public view and only accessible by direct link',
        acceptBookings: 'Accept Bookings',
        acceptBookingsOn: 'Your studio is accepting new booking requests',
        acceptBookingsOff: 'New bookings are temporarily disabled',
        musicStylesTitle: 'Music Styles & Genres',
        musicStylesSubtitle: 'Select the music styles and genres your studio specializes in',
        isPublic: 'Publicly Visible',
        isPublicHelp: 'Your studio appears in public listings and can be found by clients',
        acceptsBookings: 'Accept Bookings',
        acceptsBookingsHelp: 'Your studio is accepting new booking requests',
        musicStyles: 'Music Styles & Genres',
        musicStylesHelp: 'Add music styles and genres you specialize in to help clients find you',

        musicStylePlaceholder: 'Add music style or genre (e.g., Rock, Jazz, Hip Hop)',
        noMusicStyles: 'No music styles added yet. Add some to help clients find your studio.',
        saveButton: 'Save Studio Business Settings',
        saveSuccess: 'Studio business settings saved successfully',
        saveFailed: 'Failed to save studio business settings',
      },
      validation: {
        nameRequired: 'Organization name is required',
        invalidEmail: 'Invalid email',
        emailRequired: 'Email is required',
        phoneRequired: 'Phone is required',
        addressRequired: 'Address is required',
      },
      messages: {
        generalUpdated: 'General settings updated successfully',
        generalUpdateFailed: 'Failed to update general settings',
        settingsSaved: 'Settings saved successfully',
        saveFailed: 'Failed to save settings',
        notificationsUpdated: 'Notification settings updated successfully',
        notificationsUpdateFailed: 'Failed to update notification settings',
        notificationsSaved: 'Notification settings saved successfully',
        notificationsSaveFailed: 'Failed to save notification settings',
      },
    },
    navigation: {
      rooms: 'Rooms',
      engineers: 'Engineers',
      equipment: 'Equipment',
      services: 'Services',
      customization: 'Page Customization',
      theme: 'Studio Theme',
      showcase: 'Music Showcase',
      gallery: 'Studio Gallery',
      certifications: 'Certifications',
      artists: 'Featured Artists',
      bookings: 'Bookings',
      availability: 'Availability',
      settings: 'General Settings',
      entities: 'Entities',
      operations: 'Operations',
    },
    forms: {
      labels: {
        name: 'Name',
        description: 'Description',
        capacity: 'Capacity',
        hourlyRate: 'Hourly Rate (€)',
        email: 'Email Address',
        phone: 'Phone Number',
        website: 'Website',
        instagram: 'Instagram',
        soundcloud: 'SoundCloud',
        spotify: 'Spotify',
        youtube: 'YouTube',
        yearsOfExperience: 'Years of Experience',
        specialties: 'Specialties',
        bio: 'Biography',
        serialNumber: 'Serial Number',
        model: 'Model',
        brand: 'Brand',
        purchaseDate: 'Purchase Date',
        warrantyExpiration: 'Warranty Expiration',
        notes: 'Notes',
        type: 'Type',
        condition: 'Condition',
        category: 'Category',
        title: 'Title',
        url: 'URL',
        platform: 'Platform',
        genre: 'Genre',
        issuedBy: 'Issued By',
        issuedDate: 'Issued Date',
        expiryDate: 'Expiry Date',
        certificateNumber: 'Certificate Number',
      },
      placeholders: {
        searchEquipment: 'Search equipment...',
        searchRooms: 'Search rooms...',
        searchEngineers: 'Search engineers...',
        roomDescription: 'Describe the room features and capabilities...',
        engineerBio: 'Tell us about your experience and expertise...',
        equipmentNotes: 'Additional notes about this equipment...',
        selectGenre: 'Select genre...',
        selectType: 'Select type...',
        selectCondition: 'Select condition...',
        selectCategory: 'Select category...',
        enterUrl: 'Enter URL...',
        enterTitle: 'Enter title...',
        searchArtists: 'Search artists...',
        artistBio: 'Artist biography and achievements...',
      },
      validation: {
        required: 'This field is required',
        emailInvalid: 'Invalid email address',
        urlInvalid: 'Invalid URL format',
        numberMin: 'Must be at least {min}',
        numberMax: 'Must be at most {max}',
        stringMin: 'Must be at least {min} characters',
        stringMax: 'Must be at most {max} characters',
      },
    },
    equipment: {
      types: {
        microphone: 'Microphone',
        outboard: 'Outboard',
        amplifier: 'Amplifier',
        synthesizer: 'Synthesizer',
        interface: 'Interface',
        monitor: 'Monitor',
        headphones: 'Headphones',
        instrument: 'Instrument',
        cable: 'Cable',
        stand: 'Stand',
        rack: 'Rack',
        computer: 'Computer',
        software: 'Software',
        other: 'Other',
      },
      conditions: {
        excellent: 'Excellent',
        good: 'Good',
        fair: 'Fair',
        poor: 'Poor',
        repairNeeded: 'Repair Needed',
      },
    },
    rooms: {
      features: {
        soundproof: 'Soundproof',
        airConditioning: 'Air Conditioning',
        naturalLight: 'Natural Light',
        pianoAvailable: 'Piano Available',
        drumsAvailable: 'Drums Available',
        guitarsAmpsAvailable: 'Guitar Amps Available',
        isolationBooth: 'Isolation Booth',
        loungeArea: 'Lounge Area',
        kitchenette: 'Kitchenette',
        parking: 'Parking',
        wifiInternet: 'WiFi/Internet',
        videoRecording: 'Video Recording',
      },
    },
    status: {
      booking: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        inProgress: 'In Progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
        noShow: 'No Show',
      },
      payment: {
        unpaid: 'Unpaid',
        partial: 'Partial',
        paid: 'Paid',
        refunded: 'Refunded',
      },
      active: 'Active',
      inactive: 'Inactive',
      available: 'Available',
      unavailable: 'Unavailable',
    },
    time: {
      days: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
      },
      units: {
        fifteenMin: '15 minutes',
        thirtyMin: '30 minutes',
        oneHour: '1 hour',
        twoHours: '2 hours',
      },
    },
    genres: {
      rock: 'Rock',
      pop: 'Pop',
      hiphop: 'Hip Hop',
      electronic: 'Electronic',
      jazz: 'Jazz',
      classical: 'Classical',
      folk: 'Folk',
      country: 'Country',
      reggae: 'Reggae',
      blues: 'Blues',
      metal: 'Metal',
      punk: 'Punk',
      funk: 'Funk',
      soul: 'Soul',
      rnb: 'R&B',
      indie: 'Indie',
      alternative: 'Alternative',
      world: 'World Music',
      experimental: 'Experimental',
      ambient: 'Ambient',
      other: 'Other',
    },
    actions: {
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      create: 'Create',
      update: 'Update',
      upload: 'Upload',
      download: 'Download',
      view: 'View',
      activate: 'Activate',
      deactivate: 'Deactivate',
      refresh: 'Refresh',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      export: 'Export',
      import: 'Import',
      duplicate: 'Duplicate',
      archive: 'Archive',
      restore: 'Restore',
      markAsCompleted: 'Mark as Completed',
      markAsPending: 'Mark as Pending',
      markAsConfirmed: 'Mark as Confirmed',
      markAsCancelled: 'Mark as Cancelled',
      markAsInProgress: 'Mark as In Progress',
      markAsNoShow: 'Mark as No Show',
      toggleStatus: 'Toggle Status',
      fullScreen: 'Full Screen',
      exitFullScreen: 'Exit Full Screen',
    },
    messages: {
      success: {
        created: '{item} created successfully',
        updated: '{item} updated successfully',
        deleted: '{item} deleted successfully',
        activated: '{item} activated successfully',
        deactivated: '{item} deactivated successfully',
        uploaded: 'File uploaded successfully',
        saved: 'Changes saved successfully',
      },
      error: {
        createFailed: 'Failed to create {item}',
        updateFailed: 'Failed to update {item}',
        deleteFailed: 'Failed to delete {item}',
        uploadFailed: 'File upload failed',
        loadFailed: 'Failed to load {item}',
        networkError: 'Network error occurred',
        unauthorizedAccess: 'Unauthorized access',
      },
      confirmation: {
        deleteItem: 'Are you sure you want to delete this {item}?',
        deleteMultiple: 'Are you sure you want to delete {count} items?',
        activateItem: 'Are you sure you want to activate this {item}?',
        deactivateItem: 'Are you sure you want to deactivate this {item}?',
      },
      info: {
        noData: 'No {item} found',
        noDataWithFilters: 'No {item} found matching your criteria',
        loading: 'Loading {item}...',
        uploading: 'Uploading file...',
        saving: 'Saving changes...',
        emptyState: 'Get started by adding your first {item}',
      },
    },
    tables: {
      headers: {
        name: 'Name',
        type: 'Type',
        status: 'Status',
        capacity: 'Capacity',
        hourlyRate: 'Hourly Rate',
        features: 'Features',
        condition: 'Condition',
        brand: 'Brand',
        model: 'Model',
        serialNumber: 'Serial Number',
        purchaseDate: 'Purchase Date',
        customer: 'Customer',
        dateTime: 'Date & Time',
        room: 'Room',
        payment: 'Payment',
        amount: 'Amount',
        actions: 'Actions',
        specialties: 'Specialties',
        experience: 'Experience',
        contact: 'Contact',
        platform: 'Platform',
        genre: 'Genre',
        category: 'Category',
        issuedBy: 'Issued By',
        validUntil: 'Valid Until',
      },
    },
    dialogs: {
      titles: {
        addRoom: 'Add New Room',
        editRoom: 'Edit Room',
        addEquipment: 'Add New Equipment',
        editEquipment: 'Edit Equipment',
        addEngineer: 'Add New Engineer',
        editEngineer: 'Edit Engineer',
        addArtist: 'Add Featured Artist',
        editArtist: 'Edit Featured Artist',
        addCertification: 'Add New Certification',
        editCertification: 'Edit Certification',
        bookingDetails: 'Booking Details',
        confirmDelete: 'Confirm Delete',
        uploadFiles: 'Upload Files',
        selectImage: 'Select Image',
        cropImage: 'Crop Image',
      },
    },
    descriptions: {
      roomManagement: 'Manage studio rooms and recording spaces',
      equipmentManagement: 'Track and manage studio equipment inventory',
      engineerManagement: 'Manage sound engineers and technical staff',
      artistManagement: 'Showcase featured artists who have worked at your studio',
      galleryManagement: 'Create a visual gallery of your studio spaces',
      certificationManagement: 'Display studio certifications and awards',
      bookingManagement: 'Manage appointments and reservations',
      availabilityManagement: 'Set up availability schedules and booking rules',
      settingsManagement: 'Configure general studio settings and preferences',
      customizationManagement: "Customize your studio's public page appearance",
      themeManagement: 'Manage studio branding and visual theme',
    },
  },

  // ManageBookings translations
  'Booking Management': 'Booking Management',
  'Manage appointments and reservations for': 'Manage appointments and reservations for',
  Table: 'Table',
  Calendar: 'Calendar',
  'Exit Full Screen': 'Exit Full Screen',
  'Full Screen': 'Full Screen',
  Refresh: 'Refresh',
  'Total Bookings': 'Total Bookings',
  Confirmed: 'Confirmed',
  'Total Revenue': 'Total Revenue',
  'Search bookings...': 'Search bookings...',
  Status: 'Status',
  Payment: 'Payment',
  'All Status': 'All Status',
  'All Payments': 'All Payments',
  'No bookings found': 'No bookings found',
  'Try adjusting your search or filter criteria': 'Try adjusting your search or filter criteria',
  'No bookings have been created yet': 'No bookings have been created yet',
  Customer: 'Customer',
  'Date & Time': 'Date & Time',
  Room: 'Room',
  Actions: 'Actions',
  Duration: 'Duration',
  Paid: 'Paid',
  'Mark as Pending': 'Mark as Pending',
  'Mark as Confirmed': 'Mark as Confirmed',
  'Mark as In Progress': 'Mark as In Progress',
  'Mark as Completed': 'Mark as Completed',
  'Mark as Cancelled': 'Mark as Cancelled',
  'Mark as No Show': 'Mark as No Show',
  'Delete Booking': 'Delete Booking',
  'Booking Details': 'Booking Details',
  'Customer Information': 'Customer Information',
  Phone: 'Phone',
  'Booking Information': 'Booking Information',
  Purpose: 'Purpose',
  'Payment Information': 'Payment Information',
  'Total Amount': 'Total Amount',
  'Paid Amount': 'Paid Amount',
  'Payment Status': 'Payment Status',
  Notes: 'Notes',
  'Customer Notes': 'Customer Notes',
  'Special Requirements': 'Special Requirements',
  'Internal Notes': 'Internal Notes',
  'Unknown Room': 'Unknown Room',
  'Invalid Date': 'Invalid Date',
  'Booking status updated successfully': 'Booking status updated successfully',
  'Failed to update booking status': 'Failed to update booking status',
  'Are you sure you want to delete this booking?': 'Are you sure you want to delete this booking?',
  'Booking deleted successfully': 'Booking deleted successfully',
  'Failed to delete booking': 'Failed to delete booking',
  'Error loading bookings': 'Error loading bookings',
  'Unknown error': 'Unknown error',
  Unpaid: 'Unpaid',
  Partial: 'Partial',
  Refunded: 'Refunded',
  'In Progress': 'In Progress',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  'No Show': 'No Show',

  // ManageRooms translations
  'Room name is required': 'Room name is required',
  'Capacity must be at least 1': 'Capacity must be at least 1',
  'Capacity is required': 'Capacity is required',
  'Hourly rate must be positive': 'Hourly rate must be positive',
  'Hourly rate is required': 'Hourly rate is required',
  'User not authenticated': 'User not authenticated',
  'Room updated successfully!': 'Room updated successfully!',
  'Room created successfully!': 'Room created successfully!',
  'Are you sure you want to delete this room?': 'Are you sure you want to delete this room?',
  'Room deleted successfully!': 'Room deleted successfully!',
  'Failed to delete room': 'Failed to delete room',
  'Room status updated': 'Room status updated',
  'Failed to update room status': 'Failed to update room status',
  'Recording Rooms': 'Recording Rooms',
  'Manage your recording studio rooms and their configurations':
    'Manage your recording studio rooms and their configurations',
  'Add Room': 'Add Room',
  'Loading rooms...': 'Loading rooms...',
  'Failed to load rooms. Please try again.': 'Failed to load rooms. Please try again.',
  'No rooms found': 'No rooms found',
  'Get started by adding your first recording room':
    'Get started by adding your first recording room',
  Image: 'Image',
  'Room Name': 'Room Name',
  Capacity: 'Capacity',
  'Hourly Rate': 'Hourly Rate',
  Features: 'Features',
  Active: 'Active',
  people: 'people',
  hour: 'hour',
  'Edit Room': 'Edit Room',
  'Add New Room': 'Add New Room',
  'Hourly Rate (€)': 'Hourly Rate (€)',
  'Room Features': 'Room Features',
  'Room Images': 'Room Images',
  'Uploading images...': 'Uploading images...',
  'Update Room': 'Update Room',
  'Create Room': 'Create Room',

  // ManageEquipment translations
  'Failed to load equipment': 'Failed to load equipment',
  'Please fill in all required fields': 'Please fill in all required fields',
  'Equipment updated successfully': 'Equipment updated successfully',
  'Equipment created successfully': 'Equipment created successfully',
  'An error occurred while saving equipment': 'An error occurred while saving equipment',
  'Are you sure you want to delete this equipment?':
    'Are you sure you want to delete this equipment?',
  'Equipment deleted successfully': 'Equipment deleted successfully',
  'An error occurred while deleting equipment': 'An error occurred while deleting equipment',
  'Equipment made available': 'Equipment made available',
  'Equipment marked unavailable': 'Equipment marked unavailable',
  'An error occurred while updating equipment': 'An error occurred while updating equipment',
  'Recording Equipment': 'Recording Equipment',
  'Manage your recording studio equipment, microphones, instruments, and gear':
    'Manage your recording studio equipment, microphones, instruments, and gear',
  'Search equipment...': 'Search equipment...',
  Availability: 'Availability',
  All: 'All',
  Unavailable: 'Unavailable',
  'Add Equipment': 'Add Equipment',
  'No Equipment Found': 'No Equipment Found',
  'Start by adding your recording studio equipment to manage availability and rental rates.':
    'Start by adding your recording studio equipment to manage availability and rental rates.',
  Equipment: 'Equipment',
  'Brand/Model': 'Brand/Model',
  Condition: 'Condition',
  Location: 'Location',
  'Equipment Name *': 'Equipment Name *',
  'Type *': 'Type *',
  Brand: 'Brand',
  Model: 'Model',
  'Serial Number': 'Serial Number',
  'Condition *': 'Condition *',
  'Hourly Rate ($)': 'Hourly Rate ($)',
  'Daily Rate ($)': 'Daily Rate ($)',
  'Weekly Rate ($)': 'Weekly Rate ($)',
  'Studio A, Storage Room, etc.': 'Studio A, Storage Room, etc.',
  Create: 'Create',

  // ManageEngineers translations
  'Manage Engineers': 'Manage Engineers',
  'Add Engineer': 'Add Engineer',
  'Sound engineer management for': 'Sound engineer management for',
  'No engineers added yet': 'No engineers added yet',
  'Add sound engineers to your team to handle recording sessions and technical support.':
    'Add sound engineers to your team to handle recording sessions and technical support.',
  'Add Your First Engineer': 'Add Your First Engineer',

  // ManageServices translations
  'Manage Services': 'Manage Services',
  'Add Service': 'Add Service',
  'Studio services management for': 'Studio services management for',
  'No services defined yet': 'No services defined yet',
  'Define services like recording, mixing, mastering, and rehearsal sessions with pricing and duration.':
    'Define services like recording, mixing, mastering, and rehearsal sessions with pricing and duration.',
  'Add Your First Service': 'Add Your First Service',

  // ManageGallery translations
  'Failed to load gallery photos': 'Failed to load gallery photos',
  'Failed to load gallery data': 'Failed to load gallery data',
  'Gallery settings saved successfully!': 'Gallery settings saved successfully!',
  'Failed to save gallery settings': 'Failed to save gallery settings',
  'Failed to upload photos': 'Failed to upload photos',
  'Photo updated successfully!': 'Photo updated successfully!',
  'Failed to save photo': 'Failed to save photo',
  'Are you sure you want to delete this photo? This action cannot be undone.':
    'Are you sure you want to delete this photo? This action cannot be undone.',
  'Photo deleted successfully!': 'Photo deleted successfully!',
  'Failed to delete photo': 'Failed to delete photo',
  'Failed to update photo order': 'Failed to update photo order',
  'Studio Gallery': 'Studio Gallery',
  'Showcase your studio with beautiful photos organized by category':
    'Showcase your studio with beautiful photos organized by category',
  'Gallery Settings': 'Gallery Settings',
  'Enable Studio Gallery': 'Enable Studio Gallery',
  'When enabled, your studio gallery will be visible in the showcase':
    'When enabled, your studio gallery will be visible in the showcase',
  'Upload Photos': 'Upload Photos',
  'Upload multiple photos at once. You can organize them by category after upload.':
    'Upload multiple photos at once. You can organize them by category after upload.',
  photos: 'photos',
  'No photos in this category yet. Upload some photos and organize them here.':
    'No photos in this category yet. Upload some photos and organize them here.',
  'Edit Photo': 'Edit Photo',
  'Add Photo': 'Add Photo',
  'Photo Title': 'Photo Title',
  Save: 'Save',

  // ManageCertifications translations
  'Failed to load certifications': 'Failed to load certifications',
  'Failed to load certifications data': 'Failed to load certifications data',
  'Certifications settings saved successfully!': 'Certifications settings saved successfully!',
  'Failed to save certifications settings': 'Failed to save certifications settings',
  'Image uploaded successfully!': 'Image uploaded successfully!',
  'Failed to upload image': 'Failed to upload image',
  'Please enter a certification title': 'Please enter a certification title',
  'Certification updated successfully!': 'Certification updated successfully!',
  'Certification added successfully!': 'Certification added successfully!',
  'Failed to save certification': 'Failed to save certification',
  'Are you sure you want to delete this certification? This action cannot be undone.':
    'Are you sure you want to delete this certification? This action cannot be undone.',
  'Certification deleted successfully!': 'Certification deleted successfully!',
  'Failed to delete certification': 'Failed to delete certification',
  'Failed to update certification order': 'Failed to update certification order',
  'Certifications & Awards': 'Certifications & Awards',
  "Showcase your studio's achievements, awards, and certifications":
    "Showcase your studio's achievements, awards, and certifications",
  'Add Certification': 'Add Certification',
  'Certifications Settings': 'Certifications Settings',
  'Enable Certifications & Awards': 'Enable Certifications & Awards',
  'When enabled, your certifications and awards will be visible in the showcase':
    'When enabled, your certifications and awards will be visible in the showcase',
  'Enable certifications above to start adding your achievements':
    'Enable certifications above to start adding your achievements',
  'Add First Certification': 'Add First Certification',
  'No certifications added yet. Add your first certification to get started!':
    'No certifications added yet. Add your first certification to get started!',
  'Issued by': 'Issued by',
  Date: 'Date',
  'Edit certification': 'Edit certification',
  'Delete certification': 'Delete certification',
  'Edit Certification': 'Edit Certification',
  'Certification Title': 'Certification Title',
  'Issuer/Organization': 'Issuer/Organization',
  'e.g., Grammy Awards, Music Producers Guild': 'e.g., Grammy Awards, Music Producers Guild',
  'Date Awarded': 'Date Awarded',
  'Describe the achievement or certification...': 'Describe the achievement or certification...',
  'Certification Image': 'Certification Image',
  Certification: 'Certification',

  // Subscription translations
  subscription: 'Subscription',
  'Current Subscription': 'Current Subscription',
  'Manage Subscription': 'Manage Subscription',
  Plan: 'Plan',
  'Current Period': 'Current Period',
  'Cancel Subscription': 'Cancel Subscription',
  'Your subscription will be canceled on': 'Your subscription will be canceled on',
  'You do not have an active subscription. Choose a plan below to get started.':
    'You do not have an active subscription. Choose a plan below to get started.',
  'Available Plans': 'Available Plans',
  'Current Plan': 'Current Plan',
  month: 'month',
  year: 'year',
  Subscribe: 'Subscribe',
  'Change Plan': 'Change Plan',
  'Billing History': 'Billing History',
  Download: 'Download',
  'Keep Subscription': 'Keep Subscription',
  'Are you sure you want to cancel your subscription? You will continue to have access until the end of your current billing period.':
    'Are you sure you want to cancel your subscription? You will continue to have access until the end of your current billing period.',
  'Failed to create checkout session': 'Failed to create checkout session',
  'Failed to open customer portal': 'Failed to open customer portal',
  'Subscription will be canceled at the end of the billing period':
    'Subscription will be canceled at the end of the billing period',
  'Failed to cancel subscription': 'Failed to cancel subscription',

  // Subscription statuses
  active: 'Active',
  past_due: 'Past Due',

  unpaid: 'Unpaid',
  incomplete: 'Incomplete',
  paid: 'Paid',
  method: 'Method',

  manual: 'Manual',
  full: 'Full',
  deposit: 'Deposit',
  hold: 'Hold',

  // Import modular translations
  ...globalDashboardEn,
  ...analyticsEn,
  ...privacyEn,
  ...stripeConnectEn,
  ...campaignEn,
};

export default en;
